// import React, { useEffect, useState } from "react"
// import { MDBDataTable } from "mdbreact"
// import { Row, Col, Card, CardBody, CardTitle, Button, } from "reactstrap"

// import { connect } from "react-redux";

// //Import Action to copy breadcrumb items from local state to redux state
// import { setBreadcrumbItems, } from "../../store/actions";

// import { useDispatch } from "react-redux";
// import { useSelector } from "react-redux";
// import { Modal } from "react-bootstrap";
// import Loader from "components/Loader/Loader";
// import { toast } from "react-toastify";
// import { getAllStudents } from "helpers/student_helper";
// import { useNavigate } from "react-router-dom";
// import { Paper, TextField } from "@mui/material";
// import { DataGrid } from "@mui/x-data-grid";

// const AllStudents = (props) => {
//     document.title = "Question System | All Student";
//     const [loader, setLoader] = useState(false);
//     const [students, setStudents] = useState(null);
//     const [result, setResult] = useState([]);
//     const navigate = useNavigate();

//     const [searchStudentText, setSearchStudentText] = useState("");
//     const [filteredAllStudents, setFiltereAllStudents] = useState([]);


//     const breadcrumbItems = [
//         { title: "Student Managment", link: "#" },
//         { title: "All Students", link: "#" },
//     ]
//     useEffect(() => {
//         const blurDiv = document.getElementById("blur");
//         var width = window.innerWidth;
//         if (width <= 994) {
//             blurDiv.click()
//         }
//     }, [])

//     useEffect(() => {
//         props.setBreadcrumbItems('All Students', breadcrumbItems)


//     })

//     useEffect(() => {
//         fetchStudents();
//     }, [])

//     const fetchStudents = async () => {
//         try {
//             setLoader(true);
//             const data = await getAllStudents();
//             console.log(data.result);
//             if (data?.success) {
//                 setStudents(data?.result)
//                 setFiltereAllStudents(data?.result)
//                 setResult(data)
//             }
//         } catch (error) {
//             console.log(error);
//             toast.error("Somethng went wrong");
//         } finally {
//             setLoader(false);
//         }
//     }


//     const [page, setPage] = useState(1);

//     const data = {
//         columns: [
//             {
//                 label: "Serial No.",
//                 field: "serialNo",
//                 sort: "asc",
//                 width: 50,
//             },
//             {
//                 label: "Name",
//                 field: "fullName", // Updated field name
//                 sort: "asc",
//                 width: 100,
//             },
//             {
//                 label: "Email",
//                 field: "email",
//                 sort: "asc",
//                 width: 150,
//             },
//             {
//                 label: "Phone Number",
//                 field: "mobile",
//                 sort: "asc",
//                 width: 200,
//             },
//         ],
//         rows: students?.map((row, index) => ({
//             ...row,
//             serialNo: index + 1, // Add 1 to start counting from 1
//             fullName: `${row.firstName} ${row.lastName}`, // Concatenate first and last name
//             clickEvent: () => handleRowClick(row)
//         }))
//     };

//     const columnsStudent = [
//         { field: 'id', headerName: 'ID', width: 70 },
//         {
//             field: 'fullName',
//             headerName: 'Full Name',
//             description: 'This column has a value getter and is not sortable.',
//             sortable: false,
//             width: 200,
//             valueGetter: (value, row) => `${row?.firstName || ''} ${row?.lastName || ''}`,
//         },
//         {
//             field: 'email',
//             headerName: 'Email',
//             width: 300,
//         },
//         {
//             field: 'mobile',
//             headerName: 'Mobile',
//             width: 200,
//         },
//         {
//             field: 'actions',
//             headerName: 'Actions',
//             width: 150,
//             renderCell: (params) => (
//                 <Button
//                     variant="contained"
//                     color="warning"
//                     onClick={() => {
//                         handleRowClick(params.row);
//                         // setStudentDeleteModal(true);
//                     }}
//                 >
//                     Edit
//                 </Button>
//             ),
//         },
//     ];




//     const handleRowClick = (row) => {
//         console.log(row);
//         navigate(`/student/${row.id}`)
//     }


//     const handleDelete = () => {


//     }

//     useEffect(() => {
//         if (searchStudentText === '') {
//             setFiltereAllStudents(students);
//         } else {
//             const filtered = students.filter(student => {
//                 const firstName = student.firstName ? student.firstName.toLowerCase() : '';
//                 const lastName = student.lastName ? student.lastName.toLowerCase() : '';
//                 const email = student.email ? student.email.toLowerCase() : '';

//                 return (
//                     firstName.includes(searchStudentText.toLowerCase()) ||
//                     lastName.includes(searchStudentText.toLowerCase()) ||
//                     email.includes(searchStudentText.toLowerCase())
//                 );
//             });

//             setFiltereAllStudents(filtered);
//         }
//     }, [searchStudentText, students]);



//     return (
//         <React.Fragment>

//             {loader ? (
//                 <>
//                     < Loader />
//                 </>
//             ) : ("")}
//             <Row>
//                 <Col className="col-12">
//                     <Card>
//                         <CardBody>
//                             <CardTitle className="h4">All Students </CardTitle>
//                             <div className="mb-3 d-flex justify-content-center">
//                                 <div style={{ width: '50%' }}> {/* Adjust this percentage to control the width */}
//                                     <TextField
//                                         fullWidth
//                                         variant="outlined"
//                                         label="Search Students"
//                                         value={searchStudentText}
//                                         onChange={(e) => setSearchStudentText(e.target.value)}
//                                         sx={{ marginBottom: 2 }}
//                                     />
//                                 </div>
//                             </div>

//                             <Paper sx={{ width: '100%' }}>
//                                 <DataGrid
//                                     rows={filteredAllStudents?.map((row, index) => ({
//                                         ...row,
//                                         serialNo: index + 1,
//                                     }))}
//                                     columns={columnsStudent}
//                                     initialState={{ pagination: { paginationModel: { pageSize: 5, page: 0 } } }}
//                                     pageSizeOptions={[5, 10]}
//                                     // checkboxSelection
//                                     onSelectionModelChange={(newSelection) => handleRowClick(newSelection)}
//                                     sx={{ border: 0 }}
//                                 />
//                             </Paper>
//                         </CardBody>
//                     </Card>
//                 </Col>
//             </Row>





//         </React.Fragment>
//     )
// }

// export default connect(null, { setBreadcrumbItems })(AllStudents);







// import React, { useEffect, useState } from "react"
// import { MDBDataTable } from "mdbreact"
// import { Row, Col, Card, CardBody, CardTitle, Button, } from "reactstrap"

// import { connect } from "react-redux";

// //Import Action to copy breadcrumb items from local state to redux state
// import { setBreadcrumbItems, } from "../../store/actions";

// import { useDispatch } from "react-redux";
// import { useSelector } from "react-redux";
// import { Modal } from "react-bootstrap";
// import Loader from "components/Loader/Loader";
// import { toast } from "react-toastify";
// import { getAllStudents } from "helpers/student_helper";
// import { useNavigate } from "react-router-dom";
// import { Paper, TextField, FormControl, InputLabel, Select, MenuItem, Box, Chip } from "@mui/material";
// import { DataGrid } from "@mui/x-data-grid";

// const AllStudents = (props) => {
//     document.title = "Question System | All Student";
//     const [loader, setLoader] = useState(false);
//     const [students, setStudents] = useState(null);
//     const [result, setResult] = useState([]);
//     const navigate = useNavigate();

//     const [searchStudentText, setSearchStudentText] = useState("");
//     const [filteredAllStudents, setFiltereAllStudents] = useState([]);
    
//     // Filter states
//     const [selectedState, setSelectedState] = useState("");
//     const [selectedDivision, setSelectedDivision] = useState("");
//     const [selectedDepot, setSelectedDepot] = useState("");
//     const [selectedDepartment, setSelectedDepartment] = useState("");
    
//     // Available options for filters
//     const [states, setStates] = useState([]);
//     const [divisions, setDivisions] = useState([]);
//     const [depots, setDepots] = useState([]);
//     const [departments, setDepartments] = useState([]);

//     const breadcrumbItems = [
//         { title: "Student Managment", link: "#" },
//         { title: "All Students", link: "#" },
//     ]

//     useEffect(() => {
//         const blurDiv = document.getElementById("blur");
//         var width = window.innerWidth;
//         if (width <= 994) {
//             blurDiv.click()
//         }
//     }, [])

//     useEffect(() => {
//         props.setBreadcrumbItems('All Students', breadcrumbItems)
//     })

//     useEffect(() => {
//         fetchStudents();
//     }, [])

//     // Extract unique values for filters
//     useEffect(() => {
//         if (students) {
//             // Extract unique states
//             const uniqueStates = [...new Set(students.map(student => student.state).filter(Boolean))];
//             setStates(uniqueStates.sort());

//             // Extract unique divisions
//             const uniqueDivisions = [...new Set(students.map(student => student.division).filter(Boolean))];
//             setDivisions(uniqueDivisions.sort());

//             // Extract unique depots
//             const uniqueDepots = [...new Set(students.map(student => student.depot).filter(Boolean))];
//             setDepots(uniqueDepots.sort());

//             // Extract unique departments
//             const uniqueDepartments = [...new Set(students.map(student => student.department).filter(Boolean))];
//             setDepartments(uniqueDepartments.sort());
//         }
//     }, [students]);

//     const fetchStudents = async () => {
//         try {
//             setLoader(true);
//             const data = await getAllStudents();
//             console.log(data.result);
//             if (data?.success) {
//                 setStudents(data?.result)
//                 setFiltereAllStudents(data?.result)
//                 setResult(data)
//             }
//         } catch (error) {
//             console.log(error);
//             toast.error("Somethng went wrong");
//         } finally {
//             setLoader(false);
//         }
//     }

//     // Enhanced filtering function
//     useEffect(() => {
//         if (!students) return;

//         let filtered = students;

//         // Text search filter
//         if (searchStudentText) {
//             filtered = filtered.filter(student => {
//                 const searchTerm = searchStudentText.toLowerCase();
//                 return (
//                     (student.firstName && student.firstName.toLowerCase().includes(searchTerm)) ||
//                     (student.lastName && student.lastName.toLowerCase().includes(searchTerm)) ||
//                     (student.email && student.email.toLowerCase().includes(searchTerm)) ||
//                     (student.mobile && student.mobile.toString().includes(searchTerm)) ||
//                     (student.state && student.state.toLowerCase().includes(searchTerm)) ||
//                     (student.division && student.division.toLowerCase().includes(searchTerm)) ||
//                     (student.depot && student.depot.toLowerCase().includes(searchTerm)) ||
//                     (student.department && student.department.toLowerCase().includes(searchTerm)) ||
//                     (student.designation && student.designation.toLowerCase().includes(searchTerm)) ||
//                     (student.city && student.city.toLowerCase().includes(searchTerm)) ||
//                     (student.employeeId && student.employeeId.toString().includes(searchTerm))
//                 );
//             });
//         }

//         // State filter
//         if (selectedState) {
//             filtered = filtered.filter(student => student.state === selectedState);
//         }

//         // Division filter
//         if (selectedDivision) {
//             filtered = filtered.filter(student => student.division === selectedDivision);
//         }

//         // Depot filter
//         if (selectedDepot) {
//             filtered = filtered.filter(student => student.depot === selectedDepot);
//         }

//         // Department filter
//         if (selectedDepartment) {
//             filtered = filtered.filter(student => student.department === selectedDepartment);
//         }

//         setFiltereAllStudents(filtered);
//     }, [searchStudentText, selectedState, selectedDivision, selectedDepot, selectedDepartment, students]);

//     const [page, setPage] = useState(1);

//     const columnsStudent = [
//         { field: 'id', headerName: 'ID', width: 70 },
//         {
//             field: 'fullName',
//             headerName: 'Full Name',
//             sortable: false,
//             width: 200,
//             valueGetter: (value, row) => `${row?.firstName || ''} ${row?.lastName || ''}`,
//         },
//         {
//             field: 'email',
//             headerName: 'Email',
//             width: 250,
//         },
//         {
//             field: 'mobile',
//             headerName: 'Mobile',
//             width: 150,
//         },
//         {
//             field: 'state',
//             headerName: 'State',
//             width: 120,
//             valueGetter: (value, row) => row?.state || '--',
//         },
//         {
//             field: 'division',
//             headerName: 'Division',
//             width: 120,
//             valueGetter: (value, row) => row?.division || '--',
//         },
//         {
//             field: 'depot',
//             headerName: 'Depot',
//             width: 120,
//             valueGetter: (value, row) => row?.depot || '--',
//         },
//         {
//             field: 'department',
//             headerName: 'Department',
//             width: 120,
//             valueGetter: (value, row) => row?.department || '--',
//         },
//         {
//             field: 'actions',
//             headerName: 'Actions',
//             width: 150,
//             renderCell: (params) => (
//                 <Button
//                     variant="contained"
//                     color="warning"
//                     onClick={() => {
//                         handleRowClick(params.row);
//                     }}
//                 >
//                     Edit
//                 </Button>
//             ),
//         },
//     ];

//     const handleRowClick = (row) => {
//         console.log(row);
//         navigate(`/student/${row.id}`)
//     }

//     // Clear all filters
//     const clearAllFilters = () => {
//         setSearchStudentText("");
//         setSelectedState("");
//         setSelectedDivision("");
//         setSelectedDepot("");
//         setSelectedDepartment("");
//     }

//     // Check if any filter is active
//     const isAnyFilterActive = () => {
//         return searchStudentText || selectedState || selectedDivision || selectedDepot || selectedDepartment;
//     }

//     return (
//         <React.Fragment>
//             {loader ? (<Loader />) : ("")}
//             <Row>
//                 <Col className="col-12">
//                     <Card>
//                         <CardBody>
//                             <CardTitle className="h4">All Students</CardTitle>
                            
//                             {/* Search and Filter Section */}
//                             <Box sx={{ mb: 3 }}>
//                                 {/* Search Field */}
//                                 <div className="mb-3 d-flex justify-content-center">
//                                     <div style={{ width: '70%' }}>
//                                         <TextField
//                                             fullWidth
//                                             variant="outlined"
//                                             label="Search Students (Name, Email, Mobile, State, Division, etc.)"
//                                             value={searchStudentText}
//                                             onChange={(e) => setSearchStudentText(e.target.value)}
//                                             sx={{ marginBottom: 2 }}
//                                         />
//                                     </div>
//                                 </div>

//                                 {/* Filter Controls */}
//                                 <Row className="g-3">
//                                     <Col md={3}>
//                                         <FormControl fullWidth variant="outlined">
//                                             <InputLabel>State</InputLabel>
//                                             <Select
//                                                 value={selectedState}
//                                                 onChange={(e) => setSelectedState(e.target.value)}
//                                                 label="State"
//                                             >
//                                                 <MenuItem value="">All States</MenuItem>
//                                                 {states.map((state, index) => (
//                                                     <MenuItem key={index} value={state}>
//                                                         {state}
//                                                     </MenuItem>
//                                                 ))}
//                                             </Select>
//                                         </FormControl>
//                                     </Col>
//                                     <Col md={3}>
//                                         <FormControl fullWidth variant="outlined">
//                                             <InputLabel>Division</InputLabel>
//                                             <Select
//                                                 value={selectedDivision}
//                                                 onChange={(e) => setSelectedDivision(e.target.value)}
//                                                 label="Division"
//                                             >
//                                                 <MenuItem value="">All Divisions</MenuItem>
//                                                 {divisions.map((division, index) => (
//                                                     <MenuItem key={index} value={division}>
//                                                         {division}
//                                                     </MenuItem>
//                                                 ))}
//                                             </Select>
//                                         </FormControl>
//                                     </Col>
//                                     <Col md={3}>
//                                         <FormControl fullWidth variant="outlined">
//                                             <InputLabel>Depot</InputLabel>
//                                             <Select
//                                                 value={selectedDepot}
//                                                 onChange={(e) => setSelectedDepot(e.target.value)}
//                                                 label="Depot"
//                                             >
//                                                 <MenuItem value="">All Depots</MenuItem>
//                                                 {depots.map((depot, index) => (
//                                                     <MenuItem key={index} value={depot}>
//                                                         {depot}
//                                                     </MenuItem>
//                                                 ))}
//                                             </Select>
//                                         </FormControl>
//                                     </Col>
//                                     <Col md={3}>
//                                         <FormControl fullWidth variant="outlined">
//                                             <InputLabel>Department</InputLabel>
//                                             <Select
//                                                 value={selectedDepartment}
//                                                 onChange={(e) => setSelectedDepartment(e.target.value)}
//                                                 label="Department"
//                                             >
//                                                 <MenuItem value="">All Departments</MenuItem>
//                                                 {departments.map((department, index) => (
//                                                     <MenuItem key={index} value={department}>
//                                                         {department}
//                                                     </MenuItem>
//                                                 ))}
//                                             </Select>
//                                         </FormControl>
//                                     </Col>
//                                 </Row>

//                                 {/* Filter Status and Clear Button */}
//                                 <Box sx={{ mt: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//                                     <div>
//                                         {isAnyFilterActive() && (
//                                             <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
//                                                 {searchStudentText && (
//                                                     <Chip 
//                                                         label={`Search: ${searchStudentText}`} 
//                                                         onDelete={() => setSearchStudentText("")}
//                                                         color="primary"
//                                                         variant="outlined"
//                                                     />
//                                                 )}
//                                                 {selectedState && (
//                                                     <Chip 
//                                                         label={`State: ${selectedState}`} 
//                                                         onDelete={() => setSelectedState("")}
//                                                         color="secondary"
//                                                         variant="outlined"
//                                                     />
//                                                 )}
//                                                 {selectedDivision && (
//                                                     <Chip 
//                                                         label={`Division: ${selectedDivision}`} 
//                                                         onDelete={() => setSelectedDivision("")}
//                                                         color="success"
//                                                         variant="outlined"
//                                                     />
//                                                 )}
//                                                 {selectedDepot && (
//                                                     <Chip 
//                                                         label={`Depot: ${selectedDepot}`} 
//                                                         onDelete={() => setSelectedDepot("")}
//                                                         color="warning"
//                                                         variant="outlined"
//                                                     />
//                                                 )}
//                                                 {selectedDepartment && (
//                                                     <Chip 
//                                                         label={`Department: ${selectedDepartment}`} 
//                                                         onDelete={() => setSelectedDepartment("")}
//                                                         color="info"
//                                                         variant="outlined"
//                                                     />
//                                                 )}
//                                             </Box>
//                                         )}
//                                     </div>
                                    
//                                     {isAnyFilterActive() && (
//                                         <Button 
//                                             color="secondary" 
//                                             onClick={clearAllFilters}
//                                             size="sm"
//                                         >
//                                             Clear All Filters
//                                         </Button>
//                                     )}
//                                 </Box>

//                                 {/* Results Count */}
//                                 <Box sx={{ mt: 1 }}>
//                                     <small className="text-muted">
//                                         Showing {filteredAllStudents.length} of {students?.length || 0} students
//                                         {isAnyFilterActive() && " (filtered)"}
//                                     </small>
//                                 </Box>
//                             </Box>

//                             {/* Data Grid */}
//                             <Paper sx={{ width: '100%' }}>
//                                 <DataGrid
//                                     rows={filteredAllStudents?.map((row, index) => ({
//                                         ...row,
//                                         serialNo: index + 1,
//                                     }))}
//                                     columns={columnsStudent}
//                                     initialState={{ pagination: { paginationModel: { pageSize: 10, page: 0 } } }}
//                                     pageSizeOptions={[5, 10, 25, 50]}
//                                     sx={{ border: 0, minHeight: 400 }}
//                                     autoHeight
//                                 />
//                             </Paper>
//                         </CardBody>
//                     </Card>
//                 </Col>
//             </Row>
//         </React.Fragment>
//     )
// }

// export default connect(null, { setBreadcrumbItems })(AllStudents);













// import React, { useEffect, useState, useCallback } from "react"
// import { Row, Col, Card, CardBody, CardTitle, Button } from "reactstrap"
// import { connect } from "react-redux"
// import { setBreadcrumbItems } from "../../store/actions"
// import Loader from "components/Loader/Loader"
// import { toast } from "react-toastify"
// import { getAllStudents, fetchAllCourseOfStudent } from "helpers/student_helper"
// import { useNavigate } from "react-router-dom"
// import { 
//   Paper, 
//   TextField,
//   Grid,
//   FormControl,
//   InputLabel,
//   Select,
//   MenuItem,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Typography,
//   Box,
//   Divider,
//   Chip,
//   CircularProgress,
//   LinearProgress
// } from "@mui/material"
// import { DataGrid } from "@mui/x-data-grid"
// import DownloadIcon from '@mui/icons-material/Download'
// import PrintIcon from '@mui/icons-material/Print'
// import CloseIcon from '@mui/icons-material/Close'
// import ExcelIcon from '@mui/icons-material/GridOn'
// import DescriptionIcon from '@mui/icons-material/Description'
// import SchoolIcon from '@mui/icons-material/School'
// import CalendarTodayIcon from '@mui/icons-material/CalendarToday'
// import CheckCircleIcon from '@mui/icons-material/CheckCircle'
// import PendingIcon from '@mui/icons-material/Pending'
// import RefreshIcon from '@mui/icons-material/Refresh'

// const AllStudents = (props) => {
//   document.title = "Question System | All Students"
//   const [loader, setLoader] = useState(false)
//   const [students, setStudents] = useState([])
//   const [filteredAllStudents, setFilteredAllStudents] = useState([])
//   const [studentEnrollments, setStudentEnrollments] = useState({})
//   const [reportDialogOpen, setReportDialogOpen] = useState(false)
//   const [selectedStudent, setSelectedStudent] = useState(null)
//   const [searchText, setSearchText] = useState("")
//   const [searchField, setSearchField] = useState("all")
//   const [enrollmentsLoading, setEnrollmentsLoading] = useState({})
//   const [fetchingEnrollments, setFetchingEnrollments] = useState(false)
//   const [activeReportLoading, setActiveReportLoading] = useState(false)
//   const navigate = useNavigate()

//   const { setBreadcrumbItems } = props
  
//   const breadcrumbItems = [
//     { title: "Student Management", link: "#" },
//     { title: "All Students", link: "#" },
//   ]

//   useEffect(() => {
//     setBreadcrumbItems('All Students', breadcrumbItems)
//   }, [setBreadcrumbItems, breadcrumbItems])

//   useEffect(() => {
//     fetchStudents()
//   }, [])

//   const fetchStudents = async () => {
//     try {
//       setLoader(true)
//       const data = await getAllStudents()
//       if (data?.success) {
//         const studentsData = data?.result || []
//         setStudents(studentsData)
//         setFilteredAllStudents(studentsData)
//         toast.success(`Loaded ${studentsData.length} students`)
//       }
//     } catch (error) {
//       console.log(error)
//       toast.error("Something went wrong while fetching students")
//     } finally {
//       setLoader(false)
//     }
//   }

//   // Fixed: Handle the correct API response format from fetchAllCourseOfStudent
//   const fetchEnrollmentsForStudent = useCallback(async (studentId, forceRefresh = false) => {
//     if (studentEnrollments[studentId] && !forceRefresh) {
//       return studentEnrollments[studentId]
//     }

//     setEnrollmentsLoading(prev => ({ ...prev, [studentId]: true }))
    
//     try {
//       const enrollmentData = await fetchAllCourseOfStudent(studentId)
//       console.log("Enrollment data for student", studentId, ":", enrollmentData)
      
//       if (enrollmentData?.success) {
//         // Handle different response formats
//         let enrollmentsArray = []
        
//         if (Array.isArray(enrollmentData.result)) {
//           // Format 1: Array of enrollments
//           enrollmentsArray = enrollmentData.result
//         } else if (enrollmentData.enrollResult && Array.isArray(enrollmentData.enrollResult)) {
//           // Format 2: { enrollResult: [...] } (from StudentDetails component)
//           enrollmentsArray = enrollmentData.enrollResult
//         } else if (enrollmentData.result && Array.isArray(enrollmentData.result)) {
//           // Format 3: { result: [...] }
//           enrollmentsArray = enrollmentData.result
//         }
        
//         const processedEnrollments = enrollmentsArray.map((enrollment, index) => {
//           // Extract course information from different possible structures
//           const courseInfo = enrollment.courseDto || enrollment.course || enrollment
          
//           // Extract course name from various possible fields
//           let courseName = courseInfo.title || 
//                           courseInfo.courseName || 
//                           courseInfo.name || 
//                           enrollment.name ||
//                           courseInfo.course?.title ||
//                           "Unnamed Course"
          
//           // Extract course code if available
//           const courseCode = courseInfo.courseCode || 
//                             courseInfo.code || 
//                             enrollment.courseCode ||
//                             courseInfo.course?.courseCode ||
//                             courseInfo.course?.code ||
//                             "N/A"
          
//           // Extract enrollment date
//           const enrollmentDate = enrollment.enrollmentDate || 
//                                 enrollment.createdAt || 
//                                 enrollment.enrolledAt || 
//                                 enrollment.startDate ||
//                                 enrollment.createdDate ||
//                                 new Date()
          
//           // Extract status
//           const status = enrollment.status || 
//                         enrollment.courseStatus || 
//                         enrollment.enrollmentStatus || 
//                         courseInfo.status ||
//                         "Active"
          
//           // Extract progress
//           const progress = enrollment.progress || 
//                           enrollment.completionPercentage || 
//                           enrollment.completionRate ||
//                           courseInfo.progress ||
//                           0
          
//           // Extract instructor
//           const instructor = courseInfo.instructor || 
//                             courseInfo.teacher || 
//                             courseInfo.course?.instructor ||
//                             enrollment.instructor ||
//                             "Not specified"
          
//           return {
//             ...enrollment,
//             id: enrollment.id || enrollment.enrollmentId || `enroll-${studentId}-${index}`,
//             courseName: courseName,
//             courseCode: courseCode,
//             enrollmentDate: enrollmentDate,
//             status: status,
//             progress: Number(progress) || 0,
//             instructor: instructor,
//             // Keep original data for debugging
//             _original: enrollment
//           }
//         })
        
//         console.log("Processed enrollments for student", studentId, ":", processedEnrollments)
        
//         setStudentEnrollments(prev => ({
//           ...prev,
//           [studentId]: processedEnrollments
//         }))
        
//         return processedEnrollments
//       } else {
//         console.log("No enrollment data for student", studentId)
//         setStudentEnrollments(prev => ({
//           ...prev,
//           [studentId]: []
//         }))
//         return []
//       }
//     } catch (err) {
//       console.log(`Error fetching enrollments for student ${studentId}:`, err)
//       setStudentEnrollments(prev => ({
//         ...prev,
//         [studentId]: []
//       }))
//       return []
//     } finally {
//       setEnrollmentsLoading(prev => ({ ...prev, [studentId]: false }))
//     }
//   }, [studentEnrollments])

//   // Bulk fetch enrollments for visible students only
//   const fetchEnrollmentsForVisibleStudents = useCallback(async (studentIds) => {
//     setFetchingEnrollments(true)
    
//     try {
//       // Fetch in parallel with concurrency limit
//       const batchSize = 3 // Reduced for better performance
//       const batches = []
      
//       for (let i = 0; i < studentIds.length; i += batchSize) {
//         const batch = studentIds.slice(i, i + batchSize)
//         batches.push(batch)
//       }
      
//       for (const batch of batches) {
//         const promises = batch.map(studentId => fetchEnrollmentsForStudent(studentId))
//         await Promise.allSettled(promises) // Use allSettled to continue even if some fail
        
//         // Small delay between batches to prevent overwhelming the API
//         if (batches.indexOf(batch) < batches.length - 1) {
//           await new Promise(resolve => setTimeout(resolve, 500))
//         }
//       }
      
//       toast.success("Course enrollments loaded")
//     } catch (error) {
//       console.log("Error in bulk enrollment fetch:", error)
//       toast.error("Error loading some course enrollments")
//     } finally {
//       setFetchingEnrollments(false)
//     }
//   }, [fetchEnrollmentsForStudent])

//   const handleRowClick = (row) => {
//     navigate(`/student/${row.id}`)
//   }

//   const handleGenerateReport = async (student) => {
//     setSelectedStudent(student)
//     setReportDialogOpen(true)
//     setActiveReportLoading(true)
    
//     // Fetch enrollments for this student if not already loaded
//     if (!studentEnrollments[student.id]) {
//       await fetchEnrollmentsForStudent(student.id, true)
//     }
    
//     setActiveReportLoading(false)
//   }

//   const handleCloseReportDialog = () => {
//     setReportDialogOpen(false)
//     setSelectedStudent(null)
//   }

//   // Enhanced search functionality
//   useEffect(() => {
//     if (!students.length) return

//     const filtered = students.filter(student => {
//       if (!searchText.trim()) return true

//       const searchTerm = searchText.toLowerCase()
      
//       switch(searchField) {
//         case 'name':
//           const fullName = `${student.firstName || ''} ${student.lastName || ''}`.toLowerCase()
//           return fullName.includes(searchTerm)
        
//         case 'email':
//           return student.email?.toLowerCase().includes(searchTerm) || false
        
//         case 'mobile':
//           return student.mobile?.toLowerCase().includes(searchTerm) || false
        
//         case 'all':
//         default:
//           const firstName = student.firstName?.toLowerCase() || ''
//           const lastName = student.lastName?.toLowerCase() || ''
//           const email = student.email?.toLowerCase() || ''
//           const mobile = student.mobile?.toLowerCase() || ''
          
//           return (
//             firstName.includes(searchTerm) ||
//             lastName.includes(searchTerm) ||
//             email.includes(searchTerm) ||
//             mobile.includes(searchTerm)
//           )
//       }
//     })

//     setFilteredAllStudents(filtered)
    
//     // Fetch enrollments for visible students after search
//     if (filtered.length > 0 && filtered.length <= 30) { // Further reduced limit
//       const studentIds = filtered.map(s => s.id)
//       // Use setTimeout to prevent blocking UI
//       setTimeout(() => {
//         fetchEnrollmentsForVisibleStudents(studentIds)
//       }, 100)
//     }
//   }, [searchText, searchField, students, fetchEnrollmentsForVisibleStudents])

//   const columnsStudent = [
//     { 
//       field: 'id', 
//       headerName: 'ID', 
//       width: 80,
//     },
//     {
//       field: 'fullName',
//       headerName: 'Full Name',
//       width: 200,
//       valueGetter: (value, row) => `${row?.firstName || ''} ${row?.lastName || ''}`,
//     },
//     {
//       field: 'email',
//       headerName: 'Email',
//       width: 250,
//     },
//     {
//       field: 'mobile',
//       headerName: 'Mobile',
//       width: 150,
//     },
//     {
//       field: 'enrollmentCount',
//       headerName: 'Courses',
//       width: 130,
//       renderCell: (params) => {
//         const count = studentEnrollments[params.row.id]?.length || 0
//         const isLoading = enrollmentsLoading[params.row.id]
        
//         if (isLoading) {
//           return (
//             <Box display="flex" alignItems="center" gap={1}>
//               <CircularProgress size={16} />
//               <Typography variant="caption">Loading...</Typography>
//             </Box>
//           )
//         }
        
//         return (
//           <Box display="flex" alignItems="center" gap={1}>
//             <Chip 
//               icon={<SchoolIcon />} 
//               label={count} 
//               color={count > 0 ? "success" : "default"}
//               size="small"
//               variant="outlined"
//             />
//             {count > 0 && (
//               <Typography variant="caption" color="textSecondary">
//                 {studentEnrollments[params.row.id]?.filter(e => e.status?.toLowerCase() === 'completed').length || 0} completed
//               </Typography>
//             )}
//           </Box>
//         )
//       },
//     },
//     {
//       field: 'actions',
//       headerName: 'Actions',
//       width: 280,
//       renderCell: (params) => (
//         <div style={{ display: 'flex', gap: '8px' }}>
//           <Button
//             size="small"
//             color="primary"
//             onClick={(e) => {
//               e.stopPropagation()
//               handleRowClick(params.row)
//             }}
//           >
//             View Details
//           </Button>
//           <Button
//             size="small"
//             color="info"
//             onClick={async (e) => {
//               e.stopPropagation()
//               await handleGenerateReport(params.row)
//             }}
//             disabled={enrollmentsLoading[params.row.id]}
//           >
//             {enrollmentsLoading[params.row.id] ? (
//               <CircularProgress size={16} color="inherit" />
//             ) : (
//               "Report"
//             )}
//           </Button>
//           <Button
//             size="small"
//             color="secondary"
//             onClick={async (e) => {
//               e.stopPropagation()
//               await fetchEnrollmentsForStudent(params.row.id, true)
//               toast.success("Course data refreshed")
//             }}
//             title="Refresh course data"
//             disabled={enrollmentsLoading[params.row.id]}
//           >
//             <RefreshIcon fontSize="small" />
//           </Button>
//         </div>
//       ),
//     },
//   ]

//   // Helper function to get status color
//   const getStatusColor = (status) => {
//     if (!status) return 'default'
    
//     const statusLower = status.toLowerCase()
//     if (statusLower.includes('active') || statusLower.includes('enrolled') || statusLower.includes('in_progress')) {
//       return 'success'
//     }
//     if (statusLower.includes('complete') || statusLower.includes('finished')) {
//       return 'primary'
//     }
//     if (statusLower.includes('pending') || statusLower.includes('in progress')) {
//       return 'warning'
//     }
//     if (statusLower.includes('cancelled') || statusLower.includes('dropped')) {
//       return 'error'
//     }
//     return 'default'
//   }

//   // Helper function to get status icon
//   const getStatusIcon = (status) => {
//     if (!status) return null
    
//     const statusLower = status.toLowerCase()
//     if (statusLower.includes('active') || statusLower.includes('enrolled') || statusLower.includes('in_progress')) {
//       return <CheckCircleIcon fontSize="small" />
//     }
//     if (statusLower.includes('complete') || statusLower.includes('finished')) {
//       return <CheckCircleIcon fontSize="small" />
//     }
//     if (statusLower.includes('pending') || statusLower.includes('in progress')) {
//       return <PendingIcon fontSize="small" />
//     }
//     return null
//   }

//   // Generate Comprehensive CSV Report
//   const generateCSVReport = () => {
//     if (!selectedStudent) {
//       toast.warning("No student selected")
//       return
//     }
    
//     const enrollments = studentEnrollments[selectedStudent.id] || []
    
//     // Create CSV content
//     const csvRows = []
    
//     // Header Section
//     csvRows.push('STUDENT ACADEMIC REPORT')
//     csvRows.push(`Generated on: ${new Date().toLocaleString()}`)
//     csvRows.push('')
    
//     // Student Information Section
//     csvRows.push('STUDENT INFORMATION')
//     csvRows.push('Field,Value')
//     csvRows.push(`Student ID,${selectedStudent.id}`)
//     csvRows.push(`Full Name,"${selectedStudent.firstName} ${selectedStudent.lastName}"`)
//     csvRows.push(`Email,"${selectedStudent.email || 'N/A'}"`)
//     csvRows.push(`Mobile,"${selectedStudent.mobile || 'N/A'}"`)
//     csvRows.push('')
    
//     // Course Enrollments Section
//     csvRows.push('COURSE ENROLLMENTS')
//     if (enrollments.length > 0) {
//       csvRows.push('S.No,Course Code,Course Name,Instructor,Enrollment Date,Status,Progress (%)')
      
//       enrollments.forEach((enrollment, index) => {
//         csvRows.push([
//           index + 1,
//           `"${enrollment.courseCode}"`,
//           `"${enrollment.courseName}"`,
//           `"${enrollment.instructor}"`,
//           `"${new Date(enrollment.enrollmentDate).toLocaleDateString()}"`,
//           `"${enrollment.status}"`,
//           `${enrollment.progress}`
//         ].join(','))
//       })
//     } else {
//       csvRows.push('No course enrollments found.')
//     }
//     csvRows.push('')
    
//     // Statistics Section
//     csvRows.push('ACADEMIC STATISTICS')
//     csvRows.push('Metric,Value')
//     csvRows.push(`Total Courses,${enrollments.length}`)
//     csvRows.push(`Active Courses,${enrollments.filter(e => getStatusColor(e.status) === 'success').length}`)
//     csvRows.push(`Completed Courses,${enrollments.filter(e => getStatusColor(e.status) === 'primary').length}`)
//     csvRows.push(`In Progress,${enrollments.filter(e => getStatusColor(e.status) === 'warning').length}`)
//     csvRows.push(`Average Progress,${enrollments.length > 0 ? (enrollments.reduce((sum, e) => sum + (e.progress || 0), 0) / enrollments.length).toFixed(1) : 0}%`)
//     csvRows.push('')
    
//     // Convert to CSV string
//     const csvContent = csvRows.join('\n')
    
//     // Create and download file
//     const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
//     const url = URL.createObjectURL(blob)
//     const link = document.createElement('a')
//     link.href = url
//     link.download = `student_report_${selectedStudent.id}_${selectedStudent.firstName}_${selectedStudent.lastName}.csv`
//     document.body.appendChild(link)
//     link.click()
//     document.body.removeChild(link)
//     URL.revokeObjectURL(url)
    
//     toast.success("CSV report downloaded successfully")
//   }

//   // Generate Detailed HTML Report
//   const generateHTMLReport = () => {
//     if (!selectedStudent) {
//       toast.warning("No student selected")
//       return
//     }
    
//     const enrollments = studentEnrollments[selectedStudent.id] || []
    
//     const htmlContent = `
// <!DOCTYPE html>
// <html lang="en">
// <head>
//     <meta charset="UTF-8">
//     <meta name="viewport" content="width=device-width, initial-scale=1.0">
//     <title>Student Report - ${selectedStudent.firstName} ${selectedStudent.lastName}</title>
//     <style>
//         body {
//             font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
//             line-height: 1.6;
//             color: #333;
//             max-width: 1200px;
//             margin: 0 auto;
//             padding: 20px;
//             background: #f8f9fa;
//         }
//         .report-container {
//             background: white;
//             border-radius: 10px;
//             box-shadow: 0 0 20px rgba(0,0,0,0.1);
//             padding: 30px;
//         }
//         .header {
//             text-align: center;
//             margin-bottom: 40px;
//             padding-bottom: 20px;
//             border-bottom: 3px solid #3498db;
//             background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
//             color: white;
//             padding: 30px;
//             border-radius: 8px;
//             margin: -30px -30px 40px -30px;
//         }
//         .header h1 {
//             margin: 0;
//             font-size: 2.5em;
//         }
//         .student-info {
//             display: grid;
//             grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
//             gap: 20px;
//             margin-bottom: 40px;
//         }
//         .info-card {
//             background: #f8f9fa;
//             padding: 20px;
//             border-radius: 8px;
//             border-left: 4px solid #3498db;
//         }
//         .courses-section {
//             margin-bottom: 40px;
//         }
//         table {
//             width: 100%;
//             border-collapse: collapse;
//             margin: 20px 0;
//         }
//         th {
//             background: #2c3e50;
//             color: white;
//             padding: 12px;
//             text-align: left;
//         }
//         td {
//             padding: 12px;
//             border-bottom: 1px solid #eee;
//         }
//         .status-badge {
//             padding: 4px 10px;
//             border-radius: 12px;
//             font-size: 0.85em;
//             font-weight: bold;
//             display: inline-block;
//         }
//         .status-active { background: #d4edda; color: #155724; }
//         .status-completed { background: #d1ecf1; color: #0c5460; }
//         .status-pending { background: #fff3cd; color: #856404; }
//         .progress-bar {
//             width: 100px;
//             height: 8px;
//             background: #e9ecef;
//             border-radius: 4px;
//             overflow: hidden;
//             display: inline-block;
//             margin-right: 8px;
//         }
//         .progress-fill {
//             height: 100%;
//             background: linear-gradient(90deg, #4CAF50, #8BC34A);
//             border-radius: 4px;
//         }
//         .summary-cards {
//             display: grid;
//             grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
//             gap: 15px;
//             margin-top: 30px;
//         }
//         .summary-card {
//             text-align: center;
//             padding: 20px;
//             border-radius: 8px;
//             color: white;
//         }
//         .summary-value {
//             font-size: 2em;
//             font-weight: bold;
//             margin: 10px 0;
//         }
//         .footer {
//             text-align: center;
//             margin-top: 40px;
//             padding-top: 20px;
//             border-top: 1px solid #eee;
//             color: #7f8c8d;
//             font-size: 0.9em;
//         }
//     </style>
// </head>
// <body>
//     <div class="report-container">
//         <div class="header">
//             <h1>STUDENT REPORT</h1>
//             <p>${selectedStudent.firstName} ${selectedStudent.lastName}</p>
//             <p>Generated: ${new Date().toLocaleString()}</p>
//         </div>
        
//         <div class="student-info">
//             <div class="info-card">
//                 <h3>Student Information</h3>
//                 <p><strong>Name:</strong> ${selectedStudent.firstName} ${selectedStudent.lastName}</p>
//                 <p><strong>Email:</strong> ${selectedStudent.email || 'N/A'}</p>
//                 <p><strong>Mobile:</strong> ${selectedStudent.mobile || 'N/A'}</p>
//                 <p><strong>Student ID:</strong> ${selectedStudent.id}</p>
//             </div>
//         </div>
        
//         <div class="courses-section">
//             <h3>Course Enrollments (${enrollments.length})</h3>
//             ${enrollments.length > 0 ? `
//             <table>
//                 <thead>
//                     <tr>
//                         <th>#</th>
//                         <th>Course Name</th>
//                         <th>Code</th>
//                         <th>Enrollment Date</th>
//                         <th>Status</th>
//                         <th>Progress</th>
//                     </tr>
//                 </thead>
//                 <tbody>
//                     ${enrollments.map((enrollment, index) => {
//                         const statusClass = getStatusColor(enrollment.status) === 'success' ? 'status-active' :
//                                           getStatusColor(enrollment.status) === 'primary' ? 'status-completed' :
//                                           'status-pending'
//                         return `
//                     <tr>
//                         <td>${index + 1}</td>
//                         <td>${enrollment.courseName}</td>
//                         <td>${enrollment.courseCode}</td>
//                         <td>${new Date(enrollment.enrollmentDate).toLocaleDateString()}</td>
//                         <td><span class="status-badge ${statusClass}">${enrollment.status}</span></td>
//                         <td>
//                             <div class="progress-bar">
//                                 <div class="progress-fill" style="width: ${enrollment.progress}%"></div>
//                             </div>
//                             ${enrollment.progress}%
//                         </td>
//                     </tr>
//                         `
//                     }).join('')}
//                 </tbody>
//             </table>
//             ` : '<p>No course enrollments found.</p>'}
//         </div>
        
//         ${enrollments.length > 0 ? `
//         <div class="summary-cards">
//             <div class="summary-card" style="background: #667eea;">
//                 <div>Total Courses</div>
//                 <div class="summary-value">${enrollments.length}</div>
//             </div>
//             <div class="summary-card" style="background: #f093fb;">
//                 <div>Active</div>
//                 <div class="summary-value">${enrollments.filter(e => getStatusColor(e.status) === 'success').length}</div>
//             </div>
//             <div class="summary-card" style="background: #4facfe;">
//                 <div>Completed</div>
//                 <div class="summary-value">${enrollments.filter(e => getStatusColor(e.status) === 'primary').length}</div>
//             </div>
//         </div>
//         ` : ''}
        
//         <div class="footer">
//             <p>Generated by Learning Management System</p>
//         </div>
//     </div>
// </body>
// </html>
//     `
    
//     // Create and download HTML file
//     const blob = new Blob([htmlContent], { type: 'text/html' })
//     const url = URL.createObjectURL(blob)
//     const link = document.createElement('a')
//     link.href = url
//     link.download = `student_report_${selectedStudent.id}_${selectedStudent.firstName}_${selectedStudent.lastName}.html`
//     document.body.appendChild(link)
//     link.click()
//     document.body.removeChild(link)
//     URL.revokeObjectURL(url)
    
//     toast.success("HTML report downloaded successfully")
//   }

//   // Export all students to CSV
//   const exportAllToCSV = () => {
//     if (!filteredAllStudents.length) {
//       toast.warning("No data to export")
//       return
//     }

//     const headers = ["ID", "Full Name", "Email", "Mobile", "Courses Enrolled", "Completed Courses", "Avg Progress"]
//     const data = filteredAllStudents.map((student) => {
//       const enrollments = studentEnrollments[student.id] || []
//       const completedCount = enrollments.filter(e => getStatusColor(e.status) === 'primary').length
//       const avgProgress = enrollments.length > 0 
//         ? (enrollments.reduce((sum, e) => sum + (e.progress || 0), 0) / enrollments.length).toFixed(1)
//         : 0
      
//       return [
//         student.id,
//         `"${student.firstName} ${student.lastName}"`,
//         `"${student.email || ''}"`,
//         `"${student.mobile || ''}"`,
//         enrollments.length,
//         completedCount,
//         `${avgProgress}%`
//       ]
//     })

//     const csvContent = [
//       'ALL STUDENTS REPORT',
//       `Generated: ${new Date().toLocaleString()}`,
//       `Total Students: ${filteredAllStudents.length}`,
//       '',
//       headers.join(','),
//       ...data.map(row => row.join(','))
//     ].join('\n')

//     const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
//     const url = URL.createObjectURL(blob)
//     const link = document.createElement('a')
    
//     link.setAttribute('href', url)
//     link.setAttribute('download', `all_students_report_${new Date().toISOString().split('T')[0]}.csv`)
    
//     document.body.appendChild(link)
//     link.click()
//     document.body.removeChild(link)
//     URL.revokeObjectURL(url)
    
//     toast.success("All students report downloaded successfully")
//   }

//   // Print Report
//   const printReport = () => {
//     if (!selectedStudent) {
//       toast.warning("No student selected")
//       return
//     }
    
//     const enrollments = studentEnrollments[selectedStudent.id] || []
    
//     const printContent = `
// <!DOCTYPE html>
// <html>
// <head>
//     <title>Student Report</title>
//     <style>
//         body { font-family: Arial, sans-serif; margin: 20px; }
//         .print-header { text-align: center; margin-bottom: 20px; }
//         table { width: 100%; border-collapse: collapse; margin: 10px 0; }
//         th { background: #f0f0f0; padding: 8px; border: 1px solid #ddd; }
//         td { padding: 8px; border: 1px solid #ddd; }
//         .summary { margin-top: 20px; padding: 10px; background: #f9f9f9; }
//     </style>
// </head>
// <body>
//     <div class="print-header">
//         <h2>STUDENT REPORT</h2>
//         <p>${selectedStudent.firstName} ${selectedStudent.lastName}</p>
//         <p>Generated: ${new Date().toLocaleString()}</p>
//     </div>
    
//     <div>
//         <p><strong>Student ID:</strong> ${selectedStudent.id}</p>
//         <p><strong>Email:</strong> ${selectedStudent.email || 'N/A'}</p>
//         <p><strong>Mobile:</strong> ${selectedStudent.mobile || 'N/A'}</p>
//     </div>
    
//     <h3>Course Enrollments (${enrollments.length})</h3>
//     ${enrollments.length > 0 ? `
//     <table>
//         <thead>
//             <tr>
//                 <th>#</th>
//                 <th>Course Name</th>
//                 <th>Code</th>
//                 <th>Status</th>
//                 <th>Progress</th>
//             </tr>
//         </thead>
//         <tbody>
//             ${enrollments.map((enrollment, index) => `
//             <tr>
//                 <td>${index + 1}</td>
//                 <td>${enrollment.courseName}</td>
//                 <td>${enrollment.courseCode}</td>
//                 <td>${enrollment.status}</td>
//                 <td>${enrollment.progress}%</td>
//             </tr>
//             `).join('')}
//         </tbody>
//     </table>
//     ` : '<p>No course enrollments found.</p>'}
    
//     ${enrollments.length > 0 ? `
//     <div class="summary">
//         <p><strong>Total Courses:</strong> ${enrollments.length}</p>
//         <p><strong>Active Courses:</strong> ${enrollments.filter(e => getStatusColor(e.status) === 'success').length}</p>
//         <p><strong>Completed Courses:</strong> ${enrollments.filter(e => getStatusColor(e.status) === 'primary').length}</p>
//         <p><strong>Average Progress:</strong> ${enrollments.length > 0 ? (enrollments.reduce((sum, e) => sum + (e.progress || 0), 0) / enrollments.length).toFixed(1) : 0}%</p>
//     </div>
//     ` : ''}
    
//     <script>
//         window.onload = function() {
//             window.print();
//         }
//     </script>
// </body>
// </html>
//     `
    
//     const printWindow = window.open('', '_blank')
//     printWindow.document.write(printContent)
//     printWindow.document.close()
//   }

//   // Refresh all enrollments
//   const refreshAllEnrollments = async () => {
//     setFetchingEnrollments(true)
    
//     try {
//       const studentIds = filteredAllStudents.map(s => s.id).slice(0, 30) // Limit to first 30
//       await fetchEnrollmentsForVisibleStudents(studentIds)
//       toast.success("Course enrollments refreshed")
//     } catch (error) {
//       toast.error("Error refreshing enrollments")
//     } finally {
//       setFetchingEnrollments(false)
//     }
//   }

//   // Load initial enrollments for first page
//   useEffect(() => {
//     if (filteredAllStudents.length > 0 && filteredAllStudents.length <= 20) {
//       const studentIds = filteredAllStudents.slice(0, 10).map(s => s.id) // Load only first 10 initially
//       setTimeout(() => {
//         fetchEnrollmentsForVisibleStudents(studentIds)
//       }, 1000) // Delay to let main data load first
//     }
//   }, [filteredAllStudents, fetchEnrollmentsForVisibleStudents])

//   return (
//     <React.Fragment>
//       {loader && <Loader />}
      
//       <Row>
//         <Col className="col-12">
//           <Card>
//             <CardBody>
//               <CardTitle className="h4">
//                 All Students
//                 <div className="float-end" style={{ display: 'flex', gap: '10px' }}>
//                   <Button 
//                     color="secondary"
//                     onClick={refreshAllEnrollments}
//                     disabled={fetchingEnrollments}
//                   >
//                     <RefreshIcon /> Refresh Courses
//                   </Button>
//                   <Button 
//                     color="success"
//                     onClick={exportAllToCSV}
//                   >
//                     <DownloadIcon /> Export Report
//                   </Button>
//                 </div>
//               </CardTitle>
              
//               {/* Search and Filter Section */}
//               <Paper elevation={2} sx={{ p: 3, mb: 3 }}>
//                 <Grid container spacing={2} alignItems="center">
//                   <Grid item xs={12} md={4}>
//                     <TextField
//                       fullWidth
//                       variant="outlined"
//                       label="Search Students"
//                       value={searchText}
//                       onChange={(e) => setSearchText(e.target.value)}
//                       placeholder="Search by name, email, or mobile..."
//                     />
//                   </Grid>
//                   <Grid item xs={12} md={3}>
//                     <FormControl fullWidth>
//                       <InputLabel>Search By</InputLabel>
//                       <Select
//                         value={searchField}
//                         label="Search By"
//                         onChange={(e) => setSearchField(e.target.value)}
//                       >
//                         <MenuItem value="all">All Fields</MenuItem>
//                         <MenuItem value="name">Name Only</MenuItem>
//                         <MenuItem value="email">Email Only</MenuItem>
//                         <MenuItem value="mobile">Mobile Only</MenuItem>
//                       </Select>
//                     </FormControl>
//                   </Grid>
//                   <Grid item xs={12} md={3}>
//                     <Typography variant="body2" color="textSecondary">
//                       Showing {filteredAllStudents.length} students
//                     </Typography>
//                     <Typography variant="body2" color="textSecondary">
//                       Loaded courses for {Object.keys(studentEnrollments).length} students
//                     </Typography>
//                     {fetchingEnrollments && (
//                       <LinearProgress sx={{ mt: 1 }} />
//                     )}
//                   </Grid>
//                   <Grid item xs={12} md={2}>
//                     <Button
//                       fullWidth
//                       variant="outlined"
//                       onClick={() => {
//                         setSearchText("")
//                         setSearchField("all")
//                       }}
//                     >
//                       Clear
//                     </Button>
//                   </Grid>
//                 </Grid>
//               </Paper>

//               {/* Students Table */}
//               <Paper sx={{ width: '100%', position: 'relative' }}>
//                 {fetchingEnrollments && (
//                   <Box sx={{ position: 'absolute', top: 0, left: 0, right: 0, zIndex: 1 }}>
//                     <LinearProgress />
//                   </Box>
//                 )}
//                 <DataGrid
//                   rows={filteredAllStudents}
//                   columns={columnsStudent}
//                   initialState={{ 
//                     pagination: { 
//                       paginationModel: { 
//                         pageSize: 10, 
//                         page: 0 
//                       } 
//                     } 
//                   }}
//                   pageSizeOptions={[10, 25, 50]}
//                   sx={{ 
//                     border: 0, 
//                     minHeight: 400,
//                     '& .MuiDataGrid-cell': {
//                       padding: '8px'
//                     }
//                   }}
//                   disableRowSelectionOnClick
//                   loading={loader}
//                 />
//               </Paper>
//             </CardBody>
//           </Card>
//         </Col>
//       </Row>

//       {/* Student Report Dialog */}
//       <Dialog
//         open={reportDialogOpen}
//         onClose={handleCloseReportDialog}
//         maxWidth="lg"
//         fullWidth
//         scroll="paper"
//       >
//         <DialogTitle>
//           <Box display="flex" justifyContent="space-between" alignItems="center">
//             <Box display="flex" alignItems="center" gap={1}>
//               <SchoolIcon color="primary" />
//               <Typography variant="h6">
//                 Student Report: {selectedStudent?.firstName} {selectedStudent?.lastName}
//               </Typography>
//             </Box>
//             <Button onClick={handleCloseReportDialog} size="small">
//               <CloseIcon />
//             </Button>
//           </Box>
//         </DialogTitle>
        
//         <DialogContent dividers>
//           {activeReportLoading ? (
//             <Box display="flex" justifyContent="center" alignItems="center" minHeight={200}>
//               <CircularProgress />
//               <Typography sx={{ ml: 2 }}>Loading course data...</Typography>
//             </Box>
//           ) : selectedStudent && (
//             <Box>
//               {/* Report Header */}
//               <Box textAlign="center" mb={3}>
//                 <Typography variant="h5" gutterBottom color="primary">
//                   STUDENT REPORT
//                 </Typography>
//                 <Typography variant="subtitle2" color="textSecondary">
//                   Generated on {new Date().toLocaleDateString()} | Student ID: {selectedStudent.id}
//                 </Typography>
//               </Box>

//               <Divider sx={{ my: 2 }} />

//               {/* Student Information */}
//               <Box mb={4}>
//                 <Typography variant="h6" gutterBottom>
//                   Student Information
//                 </Typography>
//                 <Grid container spacing={2}>
//                   <Grid item xs={12} md={6}>
//                     <Paper elevation={1} sx={{ p: 2 }}>
//                       <Typography variant="body2"><strong>Name:</strong> {selectedStudent.firstName} {selectedStudent.lastName}</Typography>
//                       <Typography variant="body2"><strong>Email:</strong> {selectedStudent.email || 'N/A'}</Typography>
//                       <Typography variant="body2"><strong>Mobile:</strong> {selectedStudent.mobile || 'N/A'}</Typography>
//                     </Paper>
//                   </Grid>
//                   <Grid item xs={12} md={6}>
//                     <Paper elevation={1} sx={{ p: 2 }}>
//                       <Typography variant="body2"><strong>Student ID:</strong> {selectedStudent.id}</Typography>
//                       <Typography variant="body2"><strong>Total Courses:</strong> {studentEnrollments[selectedStudent.id]?.length || 0}</Typography>
//                       <Typography variant="body2"><strong>Completed Courses:</strong> {studentEnrollments[selectedStudent.id]?.filter(e => getStatusColor(e.status) === 'primary').length || 0}</Typography>
//                     </Paper>
//                   </Grid>
//                 </Grid>
//               </Box>

//               {/* Course Enrollments */}
//               <Box mb={4}>
//                 <Typography variant="h6" gutterBottom>
//                   Course Enrollments ({studentEnrollments[selectedStudent.id]?.length || 0})
//                 </Typography>
//                 {studentEnrollments[selectedStudent.id]?.length > 0 ? (
//                   <Paper elevation={2} sx={{ overflowX: 'auto' }}>
//                     <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '14px' }}>
//                       <thead>
//                         <tr style={{ backgroundColor: '#f5f5f5' }}>
//                           <th style={{ padding: '10px', textAlign: 'left', borderBottom: '2px solid #dee2e6' }}>#</th>
//                           <th style={{ padding: '10px', textAlign: 'left', borderBottom: '2px solid #dee2e6' }}>Course Name</th>
//                           <th style={{ padding: '10px', textAlign: 'left', borderBottom: '2px solid #dee2e6' }}>Code</th>
//                           <th style={{ padding: '10px', textAlign: 'left', borderBottom: '2px solid #dee2e6' }}>Enrollment Date</th>
//                           <th style={{ padding: '10px', textAlign: 'left', borderBottom: '2px solid #dee2e6' }}>Status</th>
//                           <th style={{ padding: '10px', textAlign: 'left', borderBottom: '2px solid #dee2e6' }}>Progress</th>
//                         </tr>
//                       </thead>
//                       <tbody>
//                         {studentEnrollments[selectedStudent.id].map((enrollment, index) => (
//                           <tr key={enrollment.id}>
//                             <td style={{ padding: '10px', borderBottom: '1px solid #dee2e6' }}>{index + 1}</td>
//                             <td style={{ padding: '10px', borderBottom: '1px solid #dee2e6' }}>
//                               {enrollment.courseName}
//                             </td>
//                             <td style={{ padding: '10px', borderBottom: '1px solid #dee2e6' }}>
//                               {enrollment.courseCode}
//                             </td>
//                             <td style={{ padding: '10px', borderBottom: '1px solid #dee2e6' }}>
//                               {new Date(enrollment.enrollmentDate).toLocaleDateString()}
//                             </td>
//                             <td style={{ padding: '10px', borderBottom: '1px solid #dee2e6' }}>
//                               <Chip 
//                                 icon={getStatusIcon(enrollment.status)}
//                                 label={enrollment.status}
//                                 size="small"
//                                 color={getStatusColor(enrollment.status)}
//                                 variant="outlined"
//                               />
//                             </td>
//                             <td style={{ padding: '10px', borderBottom: '1px solid #dee2e6' }}>
//                               <Box display="flex" alignItems="center" gap={1}>
//                                 <Box sx={{ flexGrow: 1, bgcolor: '#e9ecef', borderRadius: 1, height: 8 }}>
//                                   <Box 
//                                     sx={{ 
//                                       bgcolor: getStatusColor(enrollment.status) === 'success' ? '#4CAF50' : 
//                                               getStatusColor(enrollment.status) === 'primary' ? '#2196F3' : '#FF9800',
//                                       width: `${Math.min(enrollment.progress, 100)}%`,
//                                       height: '100%',
//                                       borderRadius: 1
//                                     }} 
//                                   />
//                                 </Box>
//                                 <Typography variant="body2" fontWeight="bold">
//                                   {enrollment.progress}%
//                                 </Typography>
//                               </Box>
//                             </td>
//                           </tr>
//                         ))}
//                       </tbody>
//                     </table>
//                   </Paper>
//                 ) : (
//                   <Paper elevation={1} sx={{ p: 4, textAlign: 'center' }}>
//                     <Typography color="textSecondary">
//                       No course enrollments found for this student.
//                     </Typography>
//                   </Paper>
//                 )}
//               </Box>

//               {/* Summary */}
//               {studentEnrollments[selectedStudent.id]?.length > 0 && (
//                 <Box>
//                   <Typography variant="h6" gutterBottom>
//                     Academic Summary
//                   </Typography>
//                   <Grid container spacing={2}>
//                     <Grid item xs={6} sm={3}>
//                       <Paper elevation={2} sx={{ p: 2, textAlign: 'center' }}>
//                         <Typography variant="h5" color="primary.main">
//                           {studentEnrollments[selectedStudent.id].length}
//                         </Typography>
//                         <Typography variant="body2" color="textSecondary">
//                           Total Courses
//                         </Typography>
//                       </Paper>
//                     </Grid>
//                     <Grid item xs={6} sm={3}>
//                       <Paper elevation={2} sx={{ p: 2, textAlign: 'center' }}>
//                         <Typography variant="h5" color="success.main">
//                           {studentEnrollments[selectedStudent.id].filter(e => getStatusColor(e.status) === 'success').length}
//                         </Typography>
//                         <Typography variant="body2" color="textSecondary">
//                           Active
//                         </Typography>
//                       </Paper>
//                     </Grid>
//                     <Grid item xs={6} sm={3}>
//                       <Paper elevation={2} sx={{ p: 2, textAlign: 'center' }}>
//                         <Typography variant="h5" color="info.main">
//                           {studentEnrollments[selectedStudent.id].filter(e => getStatusColor(e.status) === 'primary').length}
//                         </Typography>
//                         <Typography variant="body2" color="textSecondary">
//                           Completed
//                         </Typography>
//                       </Paper>
//                     </Grid>
//                     <Grid item xs={6} sm={3}>
//                       <Paper elevation={2} sx={{ p: 2, textAlign: 'center' }}>
//                         <Typography variant="h5" color="warning.main">
//                           {studentEnrollments[selectedStudent.id].filter(e => getStatusColor(e.status) === 'warning').length}
//                         </Typography>
//                         <Typography variant="body2" color="textSecondary">
//                           In Progress
//                         </Typography>
//                       </Paper>
//                     </Grid>
//                   </Grid>
//                 </Box>
//               )}
//             </Box>
//           )}
//         </DialogContent>

//         <DialogActions>
//           <Button onClick={handleCloseReportDialog} color="secondary">
//             Close
//           </Button>
//           <Button 
//             onClick={generateCSVReport}
//             color="primary"
//             startIcon={<ExcelIcon />}
//             disabled={!studentEnrollments[selectedStudent?.id]?.length}
//           >
//             CSV Report
//           </Button>
//           <Button 
//             onClick={generateHTMLReport}
//             color="info"
//             startIcon={<DescriptionIcon />}
//             disabled={!studentEnrollments[selectedStudent?.id]?.length}
//           >
//             HTML Report
//           </Button>
//           <Button 
//             onClick={printReport}
//             color="warning"
//             startIcon={<PrintIcon />}
//           >
//             Print
//           </Button>
//         </DialogActions>
//       </Dialog>
//     </React.Fragment>
//   )
// }

// export default connect(null, { setBreadcrumbItems })(AllStudents)









import React, { useEffect, useState, useCallback, useMemo } from "react"
import { Row, Col, Card, CardBody, CardTitle, Button } from "reactstrap"
import { connect } from "react-redux"
import { setBreadcrumbItems } from "../../store/actions"
import Loader from "components/Loader/Loader"
import { toast } from "react-toastify"
import { getAllStudents, fetchAllCourseOfStudent } from "helpers/student_helper"
import { useNavigate } from "react-router-dom"
import { 
  Paper, 
  TextField,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Box,
  Divider,
  Chip,
  CircularProgress,
  LinearProgress,
  Alert,
  AlertTitle,
  Tooltip,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  FormControlLabel,
  Switch
} from "@mui/material"
import { DataGrid } from "@mui/x-data-grid"
import DownloadIcon from '@mui/icons-material/Download'
import PrintIcon from '@mui/icons-material/Print'
import CloseIcon from '@mui/icons-material/Close'
import ExcelIcon from '@mui/icons-material/GridOn'
import DescriptionIcon from '@mui/icons-material/Description'
import SchoolIcon from '@mui/icons-material/School'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import PendingIcon from '@mui/icons-material/Pending'
import RefreshIcon from '@mui/icons-material/Refresh'
import VisibilityIcon from '@mui/icons-material/Visibility'
import SummarizeIcon from '@mui/icons-material/Summarize'
import PlaylistAddCheckIcon from '@mui/icons-material/PlaylistAddCheck'
import WarningIcon from '@mui/icons-material/Warning'
import ErrorIcon from '@mui/icons-material/Error'
import SpeedIcon from '@mui/icons-material/Speed'

const AllStudents = (props) => {
  document.title = "Question System | All Students"
  const [loader, setLoader] = useState(false)
  const [students, setStudents] = useState([])
  const [filteredAllStudents, setFilteredAllStudents] = useState([])
  const [studentEnrollments, setStudentEnrollments] = useState({})
  const [reportDialogOpen, setReportDialogOpen] = useState(false)
  const [selectedStudent, setSelectedStudent] = useState(null)
  const [searchText, setSearchText] = useState("")
  const [searchField, setSearchField] = useState("all")
  const [enrollmentsLoading, setEnrollmentsLoading] = useState({})
  const [fetchingEnrollments, setFetchingEnrollments] = useState(false)
  const [activeReportLoading, setActiveReportLoading] = useState(false)
  const [scanDialogOpen, setScanDialogOpen] = useState(false)
  const [scanInProgress, setScanInProgress] = useState(false)
  const [scanProgress, setScanProgress] = useState(0)
  const [scanResults, setScanResults] = useState(null)
  const [scanFilter, setScanFilter] = useState({
    includeInactive: false,
    minProgress: 0,
    maxProgress: 100,
    statusFilters: ['active', 'completed', 'in_progress', 'pending']
  })
  const [bulkExportLoading, setBulkExportLoading] = useState(false)
  const navigate = useNavigate()

  const { setBreadcrumbItems } = props

  useEffect(() => {
    // Move breadcrumbItems inside useEffect to avoid dependency warning
    const breadcrumbItems = [
      { title: "Student Management", link: "#" },
      { title: "All Students", link: "#" },
    ]
    setBreadcrumbItems('All Students', breadcrumbItems)
  }, [setBreadcrumbItems])

  useEffect(() => {
    fetchStudents()
  }, [])

  const fetchStudents = async () => {
    try {
      setLoader(true)
      const data = await getAllStudents()
      if (data?.success) {
        const studentsData = data?.result || []
        setStudents(studentsData)
        setFilteredAllStudents(studentsData)
        toast.success(`Loaded ${studentsData.length} students`)
      }
    } catch (error) {
      console.log(error)
      toast.error("Something went wrong while fetching students")
    } finally {
      setLoader(false)
    }
  }

  // Enhanced enrollment fetching with better error handling
  const fetchEnrollmentsForStudent = useCallback(async (studentId, forceRefresh = false) => {
    if (studentEnrollments[studentId] && !forceRefresh) {
      return studentEnrollments[studentId]
    }

    setEnrollmentsLoading(prev => ({ ...prev, [studentId]: true }))
    
    try {
      const enrollmentData = await fetchAllCourseOfStudent(studentId)
      
      if (enrollmentData?.success) {
        let enrollmentsArray = []
        
        if (Array.isArray(enrollmentData.result)) {
          enrollmentsArray = enrollmentData.result
        } else if (enrollmentData.enrollResult && Array.isArray(enrollmentData.enrollResult)) {
          enrollmentsArray = enrollmentData.enrollResult
        } else if (enrollmentData.result && Array.isArray(enrollmentData.result)) {
          enrollmentsArray = enrollmentData.result
        }
        
        const processedEnrollments = enrollmentsArray.map((enrollment, index) => {
          const courseInfo = enrollment.courseDto || enrollment.course || enrollment
          
          let courseName = courseInfo.title || 
                          courseInfo.courseName || 
                          courseInfo.name || 
                          enrollment.name ||
                          courseInfo.course?.title ||
                          "Unnamed Course"
          
          const courseCode = courseInfo.courseCode || 
                            courseInfo.code || 
                            enrollment.courseCode ||
                            courseInfo.course?.courseCode ||
                            courseInfo.course?.code ||
                            "N/A"
          
          const enrollmentDate = enrollment.enrollmentDate || 
                                enrollment.createdAt || 
                                enrollment.enrolledAt || 
                                enrollment.startDate ||
                                enrollment.createdDate ||
                                new Date()
          
          const status = enrollment.status || 
                        enrollment.courseStatus || 
                        enrollment.enrollmentStatus || 
                        courseInfo.status ||
                        "Active"
          
          const progress = enrollment.progress || 
                          enrollment.completionPercentage || 
                          enrollment.completionRate ||
                          courseInfo.progress ||
                          0
          
          const instructor = courseInfo.instructor || 
                            courseInfo.teacher || 
                            courseInfo.course?.instructor ||
                            enrollment.instructor ||
                            "Not specified"
          
          return {
            ...enrollment,
            id: enrollment.id || enrollment.enrollmentId || `enroll-${studentId}-${index}`,
            studentId: studentId,
            courseName: courseName,
            courseCode: courseCode,
            enrollmentDate: enrollmentDate,
            status: status,
            progress: Number(progress) || 0,
            instructor: instructor,
          }
        })
        
        setStudentEnrollments(prev => ({
          ...prev,
          [studentId]: processedEnrollments
        }))
        
        return processedEnrollments
      } else {
        setStudentEnrollments(prev => ({
          ...prev,
          [studentId]: []
        }))
        return []
      }
    } catch (err) {
      console.log(`Error fetching enrollments for student ${studentId}:`, err)
      setStudentEnrollments(prev => ({
        ...prev,
        [studentId]: []
      }))
      return []
    } finally {
      setEnrollmentsLoading(prev => ({ ...prev, [studentId]: false }))
    }
  }, [studentEnrollments])

  // Scan ALL students for courses
  const scanAllStudentsCourses = async () => {
    setScanDialogOpen(true)
    setScanInProgress(true)
    setScanProgress(0)
    setScanResults(null)
    
    const allStudentIds = filteredAllStudents.map(s => s.id)
    const totalStudents = allStudentIds.length
    let successCount = 0
    let failCount = 0
    let totalCourses = 0
    const courseStatusSummary = {
      active: 0,
      completed: 0,
      pending: 0,
      in_progress: 0,
      cancelled: 0
    }
    
    const batchSize = 5 // Process 5 students at a time
    const batches = []
    
    for (let i = 0; i < allStudentIds.length; i += batchSize) {
      batches.push(allStudentIds.slice(i, i + batchSize))
    }
    
    try {
      for (let batchIndex = 0; batchIndex < batches.length; batchIndex++) {
        const batch = batches[batchIndex]
        const promises = batch.map(async (studentId) => {
          try {
            const enrollments = await fetchEnrollmentsForStudent(studentId, true)
            return { studentId, enrollments, success: true }
          } catch (error) {
            return { studentId, enrollments: [], success: false, error }
          }
        })
        
        const results = await Promise.allSettled(promises)
        
        for (const result of results) {
          if (result.status === 'fulfilled') {
            const { studentId, enrollments, success } = result.value
            if (success) {
              successCount++
              totalCourses += enrollments.length
              
              // Count statuses
              enrollments.forEach(enrollment => {
                const status = enrollment.status?.toLowerCase() || 'active'
                if (status.includes('active') || status.includes('enrolled')) {
                  courseStatusSummary.active++
                } else if (status.includes('complete') || status.includes('finished')) {
                  courseStatusSummary.completed++
                } else if (status.includes('pending')) {
                  courseStatusSummary.pending++
                } else if (status.includes('progress') || status.includes('in_progress')) {
                  courseStatusSummary.in_progress++
                } else if (status.includes('cancel') || status.includes('drop')) {
                  courseStatusSummary.cancelled++
                } else {
                  courseStatusSummary.active++
                }
              })
            } else {
              failCount++
            }
          } else {
            failCount++
          }
        }
        
        // Update progress
        const progress = Math.round(((batchIndex + 1) / batches.length) * 100)
        setScanProgress(progress)
        
        // Small delay between batches
        if (batchIndex < batches.length - 1) {
          await new Promise(resolve => setTimeout(resolve, 300))
        }
      }
      
      // Set scan results
      setScanResults({
        totalStudents,
        successCount,
        failCount,
        totalCourses,
        courseStatusSummary,
        scannedAt: new Date().toISOString()
      })
      
      toast.success(`Successfully scanned ${successCount} students, found ${totalCourses} courses`)
    } catch (error) {
      console.error("Scan error:", error)
      toast.error("Error during scan process")
    } finally {
      setScanInProgress(false)
    }
  }

  // Get comprehensive statistics
  const getComprehensiveStats = useMemo(() => {
    const allEnrollments = Object.values(studentEnrollments).flat()
    
    // Student statistics
    const studentsWithEnrollments = filteredAllStudents.filter(s => 
      studentEnrollments[s.id] && studentEnrollments[s.id].length > 0
    ).length
    
    const studentsWithoutEnrollments = filteredAllStudents.filter(s => 
      !studentEnrollments[s.id] || studentEnrollments[s.id].length === 0
    ).length
    
    // Course statistics
    const totalCourses = allEnrollments.length
    const uniqueCourses = [...new Set(allEnrollments.map(e => e.courseCode))].length
    
    // Status statistics
    const statusStats = {
      active: allEnrollments.filter(e => 
        e.status?.toLowerCase().includes('active') || 
        e.status?.toLowerCase().includes('enrolled')
      ).length,
      completed: allEnrollments.filter(e => 
        e.status?.toLowerCase().includes('complete') || 
        e.status?.toLowerCase().includes('finished')
      ).length,
      inProgress: allEnrollments.filter(e => 
        e.status?.toLowerCase().includes('progress') || 
        e.status?.toLowerCase().includes('in_progress')
      ).length,
      pending: allEnrollments.filter(e => 
        e.status?.toLowerCase().includes('pending')
      ).length,
      cancelled: allEnrollments.filter(e => 
        e.status?.toLowerCase().includes('cancel') || 
        e.status?.toLowerCase().includes('drop')
      ).length
    }
    
    // Progress statistics
    const avgProgress = totalCourses > 0 
      ? (allEnrollments.reduce((sum, e) => sum + (e.progress || 0), 0) / totalCourses).toFixed(1)
      : 0
    
    const completedProgress = allEnrollments.filter(e => e.progress >= 100).length
    const highProgress = allEnrollments.filter(e => e.progress >= 75 && e.progress < 100).length
    const mediumProgress = allEnrollments.filter(e => e.progress >= 25 && e.progress < 75).length
    const lowProgress = allEnrollments.filter(e => e.progress > 0 && e.progress < 25).length
    const noProgress = allEnrollments.filter(e => e.progress === 0).length
    
    return {
      students: {
        total: filteredAllStudents.length,
        withEnrollments: studentsWithEnrollments,
        withoutEnrollments: studentsWithoutEnrollments,
        enrollmentPercentage: filteredAllStudents.length > 0 
          ? ((studentsWithEnrollments / filteredAllStudents.length) * 100).toFixed(1)
          : 0
      },
      courses: {
        total: totalCourses,
        unique: uniqueCourses,
        perStudent: studentsWithEnrollments > 0 
          ? (totalCourses / studentsWithEnrollments).toFixed(2)
          : 0
      },
      status: statusStats,
      progress: {
        average: avgProgress,
        distribution: {
          completed: completedProgress,
          high: highProgress,
          medium: mediumProgress,
          low: lowProgress,
          none: noProgress
        }
      },
      lastUpdated: Object.keys(studentEnrollments).length > 0 
        ? new Date().toLocaleString()
        : 'Not scanned'
    }
  }, [studentEnrollments, filteredAllStudents])

  // Handle row click
  const handleRowClick = (row) => {
    navigate(`/student/${row.id}`)
  }

  const handleGenerateReport = async (student) => {
    setSelectedStudent(student)
    setReportDialogOpen(true)
    setActiveReportLoading(true)
    
    if (!studentEnrollments[student.id]) {
      await fetchEnrollmentsForStudent(student.id, true)
    }
    
    setActiveReportLoading(false)
  }

  const handleCloseReportDialog = () => {
    setReportDialogOpen(false)
    setSelectedStudent(null)
  }

  // Enhanced search functionality
  useEffect(() => {
    if (!students.length) return

    const filtered = students.filter(student => {
      if (!searchText.trim()) return true

      const searchTerm = searchText.toLowerCase()
      
      switch(searchField) {
        case 'name':
          const fullName = `${student.firstName || ''} ${student.lastName || ''}`.toLowerCase()
          return fullName.includes(searchTerm)
        
        case 'email':
          return student.email?.toLowerCase().includes(searchTerm) || false
        
        case 'mobile':
          return student.mobile?.toLowerCase().includes(searchTerm) || false
        
        case 'course':
          // Search in student's course names
          const courseEnrollments = studentEnrollments[student.id] || []
          return courseEnrollments.some(enrollment => 
            enrollment.courseName?.toLowerCase().includes(searchTerm) ||
            enrollment.courseCode?.toLowerCase().includes(searchTerm)
          )
        
        case 'all':
        default:
          const firstName = student.firstName?.toLowerCase() || ''
          const lastName = student.lastName?.toLowerCase() || ''
          const email = student.email?.toLowerCase() || ''
          const mobile = student.mobile?.toLowerCase() || ''
          const studentEnrollmentsData = studentEnrollments[student.id] || []
          const hasCourseMatch = studentEnrollmentsData.some(enrollment => 
            enrollment.courseName?.toLowerCase().includes(searchTerm) ||
            enrollment.courseCode?.toLowerCase().includes(searchTerm)
          )
          
          return (
            firstName.includes(searchTerm) ||
            lastName.includes(searchTerm) ||
            email.includes(searchTerm) ||
            mobile.includes(searchTerm) ||
            hasCourseMatch
          )
      }
    })

    setFilteredAllStudents(filtered)
  }, [searchText, searchField, students, studentEnrollments])

  const columnsStudent = [
    { 
      field: 'id', 
      headerName: 'ID', 
      width: 80,
    },
    {
      field: 'fullName',
      headerName: 'Full Name',
      width: 180,
      valueGetter: (value, row) => `${row?.firstName || ''} ${row?.lastName || ''}`,
    },
    {
      field: 'email',
      headerName: 'Email',
      width: 220,
    },
    {
      field: 'mobile',
      headerName: 'Mobile',
      width: 130,
    },
    {
      field: 'enrollmentStats',
      headerName: 'Course Status',
      width: 200,
      renderCell: (params) => {
        const enrollments = studentEnrollments[params.row.id] || []
        const isLoading = enrollmentsLoading[params.row.id]
        
        if (isLoading) {
          return (
            <Box display="flex" alignItems="center" gap={1}>
              <CircularProgress size={16} />
              <Typography variant="caption">Loading...</Typography>
            </Box>
          )
        }
        
        if (enrollments.length === 0) {
          return (
            <Chip 
              icon={<WarningIcon />} 
              label="No courses" 
              color="warning"
              size="small"
              variant="outlined"
            />
          )
        }
        
        const activeCount = enrollments.filter(e => 
          e.status?.toLowerCase().includes('active') || 
          e.status?.toLowerCase().includes('enrolled')
        ).length
        
        const completedCount = enrollments.filter(e => 
          e.status?.toLowerCase().includes('complete') || 
          e.status?.toLowerCase().includes('finished')
        ).length
        
        const avgProgress = enrollments.length > 0 
          ? (enrollments.reduce((sum, e) => sum + (e.progress || 0), 0) / enrollments.length).toFixed(0)
          : 0
        
        return (
          <Box display="flex" flexDirection="column" gap={0.5}>
            <Box display="flex" alignItems="center" gap={1}>
              <SchoolIcon fontSize="small" color="primary" />
              <Typography variant="body2">{enrollments.length} courses</Typography>
            </Box>
            <Box display="flex" gap={1}>
              <Chip 
                label={`${activeCount}A`}
                size="small"
                color="success"
                variant="outlined"
              />
              <Chip 
                label={`${completedCount}C`}
                size="small"
                color="primary"
                variant="outlined"
              />
              <Chip 
                label={`${avgProgress}%`}
                size="small"
                color="info"
                variant="outlined"
              />
            </Box>
          </Box>
        )
      },
    },
    {
      field: 'actions',
      headerName: 'Actions',
      width: 320,
      renderCell: (params) => (
        <Box display="flex" gap={1}>
          <Button
            size="small"
            color="primary"
            startIcon={<VisibilityIcon />}
            onClick={(e) => {
              e.stopPropagation()
              handleRowClick(params.row)
            }}
          >
            View
          </Button>
          <Button
            size="small"
            color="info"
            startIcon={<SummarizeIcon />}
            onClick={async (e) => {
              e.stopPropagation()
              await handleGenerateReport(params.row)
            }}
            disabled={enrollmentsLoading[params.row.id]}
          >
            {enrollmentsLoading[params.row.id] ? (
              <CircularProgress size={16} color="inherit" />
            ) : (
              "Report"
            )}
          </Button>
          <Tooltip title="Refresh course data">
            <IconButton
              size="small"
              color="secondary"
              onClick={async (e) => {
                e.stopPropagation()
                await fetchEnrollmentsForStudent(params.row.id, true)
                toast.success("Course data refreshed")
              }}
              disabled={enrollmentsLoading[params.row.id]}
            >
              <RefreshIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        </Box>
      ),
    },
  ]

  // Helper function to get status color
  const getStatusColor = (status) => {
    if (!status) return 'default'
    
    const statusLower = status.toLowerCase()
    if (statusLower.includes('active') || statusLower.includes('enrolled')) {
      return 'success'
    }
    if (statusLower.includes('complete') || statusLower.includes('finished')) {
      return 'primary'
    }
    if (statusLower.includes('progress') || statusLower.includes('in_progress')) {
      return 'info'
    }
    if (statusLower.includes('pending')) {
      return 'warning'
    }
    if (statusLower.includes('cancel') || statusLower.includes('drop')) {
      return 'error'
    }
    return 'default'
  }

  // Helper function to get status icon
  const getStatusIcon = (status) => {
    if (!status) return null
    
    const statusLower = status.toLowerCase()
    if (statusLower.includes('active') || statusLower.includes('enrolled') || statusLower.includes('in_progress')) {
      return <CheckCircleIcon fontSize="small" />
    }
    if (statusLower.includes('complete') || statusLower.includes('finished')) {
      return <CheckCircleIcon fontSize="small" />
    }
    if (statusLower.includes('pending') || statusLower.includes('in progress')) {
      return <PendingIcon fontSize="small" />
    }
    return null
  }

  // Print Report function
  const printReport = () => {
    if (!selectedStudent) {
      toast.warning("No student selected")
      return
    }
    
    const enrollments = studentEnrollments[selectedStudent.id] || []
    
    const printContent = `
<!DOCTYPE html>
<html>
<head>
    <title>Student Report</title>
    <style>
        body { font-family: Arial, sans-serif; margin: 20px; }
        .print-header { text-align: center; margin-bottom: 20px; }
        table { width: 100%; border-collapse: collapse; margin: 10px 0; }
        th { background: #f0f0f0; padding: 8px; border: 1px solid #ddd; }
        td { padding: 8px; border: 1px solid #ddd; }
        .summary { margin-top: 20px; padding: 10px; background: #f9f9f9; }
    </style>
</head>
<body>
    <div class="print-header">
        <h2>STUDENT REPORT</h2>
        <p>${selectedStudent.firstName} ${selectedStudent.lastName}</p>
        <p>Generated: ${new Date().toLocaleString()}</p>
    </div>
    
    <div>
        <p><strong>Student ID:</strong> ${selectedStudent.id}</p>
        <p><strong>Email:</strong> ${selectedStudent.email || 'N/A'}</p>
        <p><strong>Mobile:</strong> ${selectedStudent.mobile || 'N/A'}</p>
    </div>
    
    <h3>Course Enrollments (${enrollments.length})</h3>
    ${enrollments.length > 0 ? `
    <table>
        <thead>
            <tr>
                <th>#</th>
                <th>Course Name</th>
                <th>Code</th>
                <th>Status</th>
                <th>Progress</th>
            </tr>
        </thead>
        <tbody>
            ${enrollments.map((enrollment, index) => `
            <tr>
                <td>${index + 1}</td>
                <td>${enrollment.courseName}</td>
                <td>${enrollment.courseCode}</td>
                <td>${enrollment.status}</td>
                <td>${enrollment.progress}%</td>
            </tr>
            `).join('')}
        </tbody>
    </table>
    ` : '<p>No course enrollments found.</p>'}
    
    ${enrollments.length > 0 ? `
    <div class="summary">
        <p><strong>Total Courses:</strong> ${enrollments.length}</p>
        <p><strong>Active Courses:</strong> ${enrollments.filter(e => getStatusColor(e.status) === 'success').length}</p>
        <p><strong>Completed Courses:</strong> ${enrollments.filter(e => getStatusColor(e.status) === 'primary').length}</p>
        <p><strong>Average Progress:</strong> ${enrollments.length > 0 ? (enrollments.reduce((sum, e) => sum + (e.progress || 0), 0) / enrollments.length).toFixed(1) : 0}%</p>
    </div>
    ` : ''}
    
    <script>
        window.onload = function() {
            window.print();
        }
    </script>
</body>
</html>
    `
    
    const printWindow = window.open('', '_blank')
    printWindow.document.write(printContent)
    printWindow.document.close()
  }

  // Generate HTML Report function
  const generateHTMLReport = () => {
    if (!selectedStudent) {
      toast.warning("No student selected")
      return
    }
    
    const enrollments = studentEnrollments[selectedStudent.id] || []
    
    const htmlContent = `
<!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Student Report - ${selectedStudent.firstName} ${selectedStudent.lastName}</title>
    <style>
        body {
            font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
            line-height: 1.6;
            color: #333;
            max-width: 1200px;
            margin: 0 auto;
            padding: 20px;
            background: #f8f9fa;
        }
        .report-container {
            background: white;
            border-radius: 10px;
            box-shadow: 0 0 20px rgba(0,0,0,0.1);
            padding: 30px;
        }
        .header {
            text-align: center;
            margin-bottom: 40px;
            padding-bottom: 20px;
            border-bottom: 3px solid #3498db;
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
            color: white;
            padding: 30px;
            border-radius: 8px;
            margin: -30px -30px 40px -30px;
        }
        .header h1 {
            margin: 0;
            font-size: 2.5em;
        }
        .student-info {
            display: grid;
            grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
            gap: 20px;
            margin-bottom: 40px;
        }
        .info-card {
            background: #f8f9fa;
            padding: 20px;
            border-radius: 8px;
            border-left: 4px solid #3498db;
        }
        .courses-section {
            margin-bottom: 40px;
        }
        table {
            width: 100%;
            border-collapse: collapse;
            margin: 20px 0;
        }
        th {
            background: #2c3e50;
            color: white;
            padding: 12px;
            text-align: left;
        }
        td {
            padding: 12px;
            border-bottom: 1px solid #eee;
        }
        .status-badge {
            padding: 4px 10px;
            border-radius: 12px;
            font-size: 0.85em;
            font-weight: bold;
            display: inline-block;
        }
        .status-active { background: #d4edda; color: #155724; }
        .status-completed { background: #d1ecf1; color: #0c5460; }
        .status-pending { background: #fff3cd; color: #856404; }
        .progress-bar {
            width: 100px;
            height: 8px;
            background: #e9ecef;
            border-radius: 4px;
            overflow: hidden;
            display: inline-block;
            margin-right: 8px;
        }
        .progress-fill {
            height: 100%;
            background: linear-gradient(90deg, #4CAF50, #8BC34A);
            border-radius: 4px;
        }
        .summary-cards {
            display: grid;
            grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
            gap: 15px;
            margin-top: 30px;
        }
        .summary-card {
            text-align: center;
            padding: 20px;
            border-radius: 8px;
            color: white;
        }
        .summary-value {
            font-size: 2em;
            font-weight: bold;
            margin: 10px 0;
        }
        .footer {
            text-align: center;
            margin-top: 40px;
            padding-top: 20px;
            border-top: 1px solid #eee;
            color: #7f8c8d;
            font-size: 0.9em;
        }
    </style>
</head>
<body>
    <div class="report-container">
        <div class="header">
            <h1>STUDENT REPORT</h1>
            <p>${selectedStudent.firstName} ${selectedStudent.lastName}</p>
            <p>Generated: ${new Date().toLocaleString()}</p>
        </div>
        
        <div class="student-info">
            <div class="info-card">
                <h3>Student Information</h3>
                <p><strong>Name:</strong> ${selectedStudent.firstName} ${selectedStudent.lastName}</p>
                <p><strong>Email:</strong> ${selectedStudent.email || 'N/A'}</p>
                <p><strong>Mobile:</strong> ${selectedStudent.mobile || 'N/A'}</p>
                <p><strong>Student ID:</strong> ${selectedStudent.id}</p>
            </div>
        </div>
        
        <div class="courses-section">
            <h3>Course Enrollments (${enrollments.length})</h3>
            ${enrollments.length > 0 ? `
            <table>
                <thead>
                    <tr>
                        <th>#</th>
                        <th>Course Name</th>
                        <th>Code</th>
                        <th>Enrollment Date</th>
                        <th>Status</th>
                        <th>Progress</th>
                    </tr>
                </thead>
                <tbody>
                    ${enrollments.map((enrollment, index) => {
                        const statusClass = getStatusColor(enrollment.status) === 'success' ? 'status-active' :
                                          getStatusColor(enrollment.status) === 'primary' ? 'status-completed' :
                                          'status-pending'
                        return `
                    <tr>
                        <td>${index + 1}</td>
                        <td>${enrollment.courseName}</td>
                        <td>${enrollment.courseCode}</td>
                        <td>${new Date(enrollment.enrollmentDate).toLocaleDateString()}</td>
                        <td><span class="status-badge ${statusClass}">${enrollment.status}</span></td>
                        <td>
                            <div class="progress-bar">
                                <div class="progress-fill" style="width: ${enrollment.progress}%"></div>
                            </div>
                            ${enrollment.progress}%
                        </td>
                    </tr>
                        `
                    }).join('')}
                </tbody>
            </table>
            ` : '<p>No course enrollments found.</p>'}
        </div>
        
        ${enrollments.length > 0 ? `
        <div class="summary-cards">
            <div class="summary-card" style="background: #667eea;">
                <div>Total Courses</div>
                <div class="summary-value">${enrollments.length}</div>
            </div>
            <div class="summary-card" style="background: #f093fb;">
                <div>Active</div>
                <div class="summary-value">${enrollments.filter(e => getStatusColor(e.status) === 'success').length}</div>
            </div>
            <div class="summary-card" style="background: #4facfe;">
                <div>Completed</div>
                <div class="summary-value">${enrollments.filter(e => getStatusColor(e.status) === 'primary').length}</div>
            </div>
        </div>
        ` : ''}
        
        <div class="footer">
            <p>Generated by Learning Management System</p>
        </div>
    </div>
</body>
</html>
    `
    
    // Create and download HTML file
    const blob = new Blob([htmlContent], { type: 'text/html' })
    const url = URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.download = `student_report_${selectedStudent.id}_${selectedStudent.firstName}_${selectedStudent.lastName}.html`
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    URL.revokeObjectURL(url)
    
    toast.success("HTML report downloaded successfully")
  }

  // Generate Comprehensive All Students CSV Report
  const generateAllStudentsCSVReport = async () => {
    setBulkExportLoading(true)
    
    try {
      // Ensure we have data for all students
      const studentIds = filteredAllStudents.map(s => s.id)
      const batchSize = 10
      
      for (let i = 0; i < studentIds.length; i += batchSize) {
        const batch = studentIds.slice(i, i + batchSize)
        await Promise.allSettled(
          batch.map(id => fetchEnrollmentsForStudent(id, true))
        )
        
        // Update progress
        const progress = Math.round(((i + batchSize) / studentIds.length) * 100)
        setScanProgress(Math.min(progress, 95))
        
        if (i + batchSize < studentIds.length) {
          await new Promise(resolve => setTimeout(resolve, 500))
        }
      }
      
      // Create CSV content
      const csvRows = []
      
      // Header Section
      csvRows.push('COMPREHENSIVE STUDENTS COURSE REPORT')
      csvRows.push(`Generated on: ${new Date().toLocaleString()}`)
      csvRows.push('')
      
      // Summary Statistics
      csvRows.push('SUMMARY STATISTICS')
      csvRows.push('Metric,Value')
      csvRows.push(`Total Students,${filteredAllStudents.length}`)
      csvRows.push(`Students with Courses,${getComprehensiveStats.students.withEnrollments}`)
      csvRows.push(`Total Courses,${getComprehensiveStats.courses.total}`)
      csvRows.push(`Unique Courses,${getComprehensiveStats.courses.unique}`)
      csvRows.push(`Average Courses per Student,${getComprehensiveStats.courses.perStudent}`)
      csvRows.push(`Active Courses,${getComprehensiveStats.status.active}`)
      csvRows.push(`Completed Courses,${getComprehensiveStats.status.completed}`)
      csvRows.push(`In Progress Courses,${getComprehensiveStats.status.inProgress}`)
      csvRows.push(`Average Progress,${getComprehensiveStats.progress.average}%`)
      csvRows.push('')
      
      // Student Details Section
      csvRows.push('STUDENT DETAILS')
      csvRows.push('Student ID,Full Name,Email,Mobile,Total Courses,Active,Completed,Avg Progress,Status Summary')
      
      filteredAllStudents.forEach((student) => {
        const enrollments = studentEnrollments[student.id] || []
        const activeCount = enrollments.filter(e => getStatusColor(e.status) === 'success').length
        const completedCount = enrollments.filter(e => getStatusColor(e.status) === 'primary').length
        const avgProgress = enrollments.length > 0 
          ? (enrollments.reduce((sum, e) => sum + (e.progress || 0), 0) / enrollments.length).toFixed(1)
          : 0
        
        csvRows.push([
          student.id,
          `"${student.firstName} ${student.lastName}"`,
          `"${student.email || ''}"`,
          `"${student.mobile || ''}"`,
          enrollments.length,
          activeCount,
          completedCount,
          `${avgProgress}%`,
          `"Active: ${activeCount}, Completed: ${completedCount}"`
        ].join(','))
      })
      csvRows.push('')
      
      // Course Details Section
      csvRows.push('COURSE ENROLLMENT DETAILS')
      csvRows.push('Student ID,Student Name,Course Code,Course Name,Enrollment Date,Status,Progress (%),Instructor')
      
      filteredAllStudents.forEach((student) => {
        const enrollments = studentEnrollments[student.id] || []
        enrollments.forEach((enrollment) => {
          csvRows.push([
            student.id,
            `"${student.firstName} ${student.lastName}"`,
            `"${enrollment.courseCode}"`,
            `"${enrollment.courseName}"`,
            `"${new Date(enrollment.enrollmentDate).toLocaleDateString()}"`,
            `"${enrollment.status}"`,
            enrollment.progress,
            `"${enrollment.instructor}"`
          ].join(','))
        })
      })
      
      // Convert to CSV string
      const csvContent = csvRows.join('\n')
      
      // Create and download file
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
      const url = URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      link.download = `all_students_course_report_${new Date().toISOString().split('T')[0]}.csv`
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      URL.revokeObjectURL(url)
      
      toast.success(`Comprehensive report for ${filteredAllStudents.length} students downloaded successfully`)
    } catch (error) {
      console.error("Export error:", error)
      toast.error("Error generating report")
    } finally {
      setBulkExportLoading(false)
      setScanProgress(0)
    }
  }

  // Export filtered course data
  const exportFilteredCourses = () => {
    const allEnrollments = Object.values(studentEnrollments).flat()
    
    if (allEnrollments.length === 0) {
      toast.warning("No course data available to export")
      return
    }
    
    // Apply filters
    let filtered = allEnrollments
    
    if (!scanFilter.includeInactive) {
      filtered = filtered.filter(e => 
        !e.status?.toLowerCase().includes('cancel') && 
        !e.status?.toLowerCase().includes('drop')
      )
    }
    
    filtered = filtered.filter(e => 
      e.progress >= scanFilter.minProgress && 
      e.progress <= scanFilter.maxProgress
    )
    
    filtered = filtered.filter(e => 
      scanFilter.statusFilters.some(filter => 
        e.status?.toLowerCase().includes(filter.toLowerCase())
      )
    )
    
    // Create CSV
    const headers = ['Student ID', 'Student Name', 'Course Code', 'Course Name', 'Status', 'Progress (%)', 'Enrollment Date', 'Instructor']
    const data = filtered.map(enrollment => {
      const student = filteredAllStudents.find(s => s.id === enrollment.studentId)
      return [
        enrollment.studentId,
        student ? `"${student.firstName} ${student.lastName}"` : 'N/A',
        `"${enrollment.courseCode}"`,
        `"${enrollment.courseName}"`,
        `"${enrollment.status}"`,
        enrollment.progress,
        `"${new Date(enrollment.enrollmentDate).toLocaleDateString()}"`,
        `"${enrollment.instructor}"`
      ].join(',')
    })
    
    const csvContent = [
      'FILTERED COURSE ENROLLMENTS REPORT',
      `Generated: ${new Date().toLocaleString()}`,
      `Total Records: ${filtered.length}`,
      `Filters: ${scanFilter.includeInactive ? 'Include Inactive, ' : ''}Progress: ${scanFilter.minProgress}-${scanFilter.maxProgress}%, Status: ${scanFilter.statusFilters.join(', ')}`,
      '',
      headers.join(','),
      ...data
    ].join('\n')
    
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
    const url = URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.download = `filtered_courses_${new Date().toISOString().split('T')[0]}.csv`
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    URL.revokeObjectURL(url)
    
    toast.success(`Exported ${filtered.length} course records`)
  }

  return (
    <React.Fragment>
      {loader && <Loader />}
      
      <Row>
        <Col className="col-12">
          <Card>
            <CardBody>
              <CardTitle className="h4">
                All Students - Course Management
                <div className="float-end" style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                  <Button 
                    color="info"
                    onClick={scanAllStudentsCourses}
                    disabled={fetchingEnrollments || scanInProgress}
                  >
                    <PlaylistAddCheckIcon /> Scan All Courses
                  </Button>
                  <Button 
                    color="success"
                    onClick={generateAllStudentsCSVReport}
                    disabled={bulkExportLoading || filteredAllStudents.length === 0}
                  >
                    {bulkExportLoading ? (
                      <>
                        <CircularProgress size={16} color="inherit" /> Exporting...
                      </>
                    ) : (
                      <>
                        <DownloadIcon /> Export All Data
                      </>
                    )}
                  </Button>
                </div>
              </CardTitle>
              
              {/* Statistics Summary Card */}
              <Paper elevation={2} sx={{ p: 3, mb: 3 }}>
                <Grid container spacing={2} alignItems="center">
                  <Grid item xs={12}>
                    <Typography variant="h6" gutterBottom color="primary">
                      <SpeedIcon sx={{ verticalAlign: 'middle', mr: 1 }} />
                      Course Enrollment Statistics
                    </Typography>
                  </Grid>
                  
                  <Grid item xs={12} md={3}>
                    <Paper elevation={1} sx={{ p: 2, textAlign: 'center', bgcolor: '#f8f9fa' }}>
                      <Typography variant="h4" color="primary">
                        {getComprehensiveStats.students.total}
                      </Typography>
                      <Typography variant="body2" color="textSecondary">
                        Total Students
                      </Typography>
                    </Paper>
                  </Grid>
                  
                  <Grid item xs={12} md={3}>
                    <Paper elevation={1} sx={{ p: 2, textAlign: 'center', bgcolor: '#f8f9fa' }}>
                      <Typography variant="h4" color="success.main">
                        {getComprehensiveStats.courses.total}
                      </Typography>
                      <Typography variant="body2" color="textSecondary">
                        Total Courses
                      </Typography>
                    </Paper>
                  </Grid>
                  
                  <Grid item xs={12} md={3}>
                    <Paper elevation={1} sx={{ p: 2, textAlign: 'center', bgcolor: '#f8f9fa' }}>
                      <Typography variant="h4" color="info.main">
                        {getComprehensiveStats.students.withEnrollments}
                      </Typography>
                      <Typography variant="body2" color="textSecondary">
                        Students with Courses
                      </Typography>
                    </Paper>
                  </Grid>
                  
                  <Grid item xs={12} md={3}>
                    <Paper elevation={1} sx={{ p: 2, textAlign: 'center', bgcolor: '#f8f9fa' }}>
                      <Typography variant="h4" color="warning.main">
                        {getComprehensiveStats.progress.average}%
                      </Typography>
                      <Typography variant="body2" color="textSecondary">
                        Avg Progress
                      </Typography>
                    </Paper>
                  </Grid>
                  
                  <Grid item xs={12}>
                    <Alert severity="info" sx={{ mt: 2 }}>
                      <AlertTitle>Data Status</AlertTitle>
                      Courses loaded for {Object.keys(studentEnrollments).length} of {filteredAllStudents.length} students. 
                      Last updated: {getComprehensiveStats.lastUpdated}
                    </Alert>
                  </Grid>
                </Grid>
              </Paper>

              {/* Search and Filter Section */}
              <Paper elevation={2} sx={{ p: 3, mb: 3 }}>
                <Grid container spacing={2} alignItems="center">
                  <Grid item xs={12} md={4}>
                    <TextField
                      fullWidth
                      variant="outlined"
                      label="Search Students & Courses"
                      value={searchText}
                      onChange={(e) => setSearchText(e.target.value)}
                      placeholder="Search by name, email, mobile, or course..."
                    />
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <FormControl fullWidth>
                      <InputLabel>Search By</InputLabel>
                      <Select
                        value={searchField}
                        label="Search By"
                        onChange={(e) => setSearchField(e.target.value)}
                      >
                        <MenuItem value="all">All Fields</MenuItem>
                        <MenuItem value="name">Name Only</MenuItem>
                        <MenuItem value="email">Email Only</MenuItem>
                        <MenuItem value="mobile">Mobile Only</MenuItem>
                        <MenuItem value="course">Course Name/Code</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <Box>
                      <Typography variant="body2" color="textSecondary">
                        Showing {filteredAllStudents.length} students
                      </Typography>
                      <Typography variant="body2" color="textSecondary">
                        {getComprehensiveStats.courses.total} courses loaded
                      </Typography>
                      {fetchingEnrollments && (
                        <LinearProgress sx={{ mt: 1 }} />
                      )}
                    </Box>
                  </Grid>
                  <Grid item xs={12} md={2}>
                    <Button
                      fullWidth
                      variant="outlined"
                      onClick={() => {
                        setSearchText("")
                        setSearchField("all")
                      }}
                    >
                      Clear Filters
                    </Button>
                  </Grid>
                </Grid>
              </Paper>

              {/* Students Table */}
              <Paper sx={{ width: '100%', position: 'relative' }}>
                {fetchingEnrollments && (
                  <Box sx={{ position: 'absolute', top: 0, left: 0, right: 0, zIndex: 1 }}>
                    <LinearProgress />
                  </Box>
                )}
                <DataGrid
                  rows={filteredAllStudents}
                  columns={columnsStudent}
                  initialState={{ 
                    pagination: { 
                      paginationModel: { 
                        pageSize: 10, 
                        page: 0 
                      } 
                    },
                    sorting: {
                      sortModel: [{ field: 'id', sort: 'asc' }]
                    }
                  }}
                  pageSizeOptions={[10, 25, 50, 100]}
                  sx={{ 
                    border: 0, 
                    minHeight: 500,
                    '& .MuiDataGrid-cell': {
                      padding: '8px',
                      display: 'flex',
                      alignItems: 'center'
                    },
                    '& .MuiDataGrid-row:hover': {
                      backgroundColor: '#f5f5f5',
                      cursor: 'pointer'
                    }
                  }}
                  disableRowSelectionOnClick
                  loading={loader}
                />
              </Paper>
            </CardBody>
          </Card>
        </Col>
      </Row>

      {/* Scan All Students Dialog */}
      <Dialog
        open={scanDialogOpen}
        onClose={() => !scanInProgress && setScanDialogOpen(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Box display="flex" alignItems="center" gap={1}>
              <PlaylistAddCheckIcon color="primary" />
              <Typography variant="h6">
                Scan All Students' Courses
              </Typography>
            </Box>
            {!scanInProgress && (
              <IconButton onClick={() => setScanDialogOpen(false)} size="small">
                <CloseIcon />
              </IconButton>
            )}
          </Box>
        </DialogTitle>
        
        <DialogContent dividers>
          {scanInProgress ? (
            <Box>
              <Box textAlign="center" mb={3}>
                <CircularProgress size={60} thickness={4} />
                <Typography variant="h6" sx={{ mt: 2 }}>
                  Scanning in progress...
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  Fetching course data for all students
                </Typography>
              </Box>
              
              <Box mt={3}>
                <LinearProgress 
                  variant="determinate" 
                  value={scanProgress} 
                  sx={{ height: 10, borderRadius: 5 }}
                />
                <Typography variant="body2" textAlign="center" mt={1}>
                  {scanProgress}% Complete
                </Typography>
              </Box>
              
              <Alert severity="info" sx={{ mt: 3 }}>
                Please don't close this window while scanning is in progress.
              </Alert>
            </Box>
          ) : scanResults ? (
            <Box>
              <Alert severity="success" sx={{ mb: 3 }}>
                <AlertTitle>Scan Completed Successfully!</AlertTitle>
                Scanned {scanResults.totalStudents} students at {new Date(scanResults.scannedAt).toLocaleTimeString()}
              </Alert>
              
              <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                  <Paper elevation={2} sx={{ p: 2 }}>
                    <Typography variant="subtitle1" gutterBottom fontWeight="bold">
                      Scan Results
                    </Typography>
                    <Table size="small">
                      <TableBody>
                        <TableRow>
                          <TableCell><strong>Total Students</strong></TableCell>
                          <TableCell>{scanResults.totalStudents}</TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell><strong>Successful Scans</strong></TableCell>
                          <TableCell>
                            <Chip label={scanResults.successCount} size="small" color="success" />
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell><strong>Failed Scans</strong></TableCell>
                          <TableCell>
                            <Chip label={scanResults.failCount} size="small" color={scanResults.failCount > 0 ? "error" : "default"} />
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell><strong>Total Courses Found</strong></TableCell>
                          <TableCell>
                            <Chip label={scanResults.totalCourses} size="small" color="info" />
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </Paper>
                </Grid>
                
                <Grid item xs={12} md={6}>
                  <Paper elevation={2} sx={{ p: 2 }}>
                    <Typography variant="subtitle1" gutterBottom fontWeight="bold">
                      Course Status Summary
                    </Typography>
                    <Table size="small">
                      <TableBody>
                        <TableRow>
                          <TableCell>Active Courses</TableCell>
                          <TableCell>
                            <Chip label={scanResults.courseStatusSummary.active} size="small" color="success" variant="outlined" />
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell>Completed Courses</TableCell>
                          <TableCell>
                            <Chip label={scanResults.courseStatusSummary.completed} size="small" color="primary" variant="outlined" />
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell>In Progress</TableCell>
                          <TableCell>
                            <Chip label={scanResults.courseStatusSummary.in_progress} size="small" color="info" variant="outlined" />
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell>Pending</TableCell>
                          <TableCell>
                            <Chip label={scanResults.courseStatusSummary.pending} size="small" color="warning" variant="outlined" />
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </Paper>
                </Grid>
              </Grid>
              
              <Box mt={3}>
                <Typography variant="subtitle2" color="textSecondary">
                  Note: Course data is now available for reporting and export.
                </Typography>
              </Box>
            </Box>
          ) : (
            <Box>
              <Alert severity="warning" sx={{ mb: 3 }}>
                <AlertTitle>Scan All Students' Courses</AlertTitle>
                This will fetch course enrollment data for all {filteredAllStudents.length} students. 
                This process may take several minutes depending on the number of students.
              </Alert>
              
              <Paper elevation={2} sx={{ p: 2, mb: 3 }}>
                <Typography variant="subtitle1" gutterBottom>
                  Scan Options
                </Typography>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <FormControlLabel
                      control={
                        <Switch
                          checked={scanFilter.includeInactive}
                          onChange={(e) => setScanFilter(prev => ({
                            ...prev,
                            includeInactive: e.target.checked
                          }))}
                        />
                      }
                      label="Include inactive/cancelled courses"
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <TextField
                      fullWidth
                      type="number"
                      label="Minimum Progress %"
                      value={scanFilter.minProgress}
                      onChange={(e) => setScanFilter(prev => ({
                        ...prev,
                        minProgress: Math.max(0, Math.min(100, parseInt(e.target.value) || 0))
                      }))}
                      InputProps={{ inputProps: { min: 0, max: 100 } }}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <TextField
                      fullWidth
                      type="number"
                      label="Maximum Progress %"
                      value={scanFilter.maxProgress}
                      onChange={(e) => setScanFilter(prev => ({
                        ...prev,
                        maxProgress: Math.max(0, Math.min(100, parseInt(e.target.value) || 100))
                      }))}
                      InputProps={{ inputProps: { min: 0, max: 100 } }}
                    />
                  </Grid>
                </Grid>
              </Paper>
            </Box>
          )}
        </DialogContent>
        
        <DialogActions>
          {scanInProgress ? (
            <Button disabled>Scanning... Please wait</Button>
          ) : scanResults ? (
            <>
              <Button onClick={() => setScanDialogOpen(false)}>
                Close
              </Button>
              <Button 
                onClick={exportFilteredCourses}
                color="primary"
                startIcon={<DownloadIcon />}
              >
                Export Filtered Data
              </Button>
              <Button 
                onClick={scanAllStudentsCourses}
                color="secondary"
                startIcon={<RefreshIcon />}
              >
                Scan Again
              </Button>
            </>
          ) : (
            <>
              <Button onClick={() => setScanDialogOpen(false)}>
                Cancel
              </Button>
              <Button 
                onClick={scanAllStudentsCourses}
                color="primary"
                variant="contained"
                startIcon={<PlaylistAddCheckIcon />}
              >
                Start Scanning
              </Button>
            </>
          )}
        </DialogActions>
      </Dialog>

      {/* Student Report Dialog */}
      <Dialog
        open={reportDialogOpen}
        onClose={handleCloseReportDialog}
        maxWidth="lg"
        fullWidth
        scroll="paper"
      >
        <DialogTitle>
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Box display="flex" alignItems="center" gap={1}>
              <SchoolIcon color="primary" />
              <Typography variant="h6">
                Student Report: {selectedStudent?.firstName} {selectedStudent?.lastName}
              </Typography>
            </Box>
            <Button onClick={handleCloseReportDialog} size="small">
              <CloseIcon />
            </Button>
          </Box>
        </DialogTitle>
        
        <DialogContent dividers>
          {activeReportLoading ? (
            <Box display="flex" justifyContent="center" alignItems="center" minHeight={200}>
              <CircularProgress />
              <Typography sx={{ ml: 2 }}>Loading course data...</Typography>
            </Box>
          ) : selectedStudent && (
            <Box>
              <Box textAlign="center" mb={3}>
                <Typography variant="h5" gutterBottom color="primary">
                  STUDENT REPORT
                </Typography>
                <Typography variant="subtitle2" color="textSecondary">
                  Generated on {new Date().toLocaleDateString()} | Student ID: {selectedStudent.id}
                </Typography>
              </Box>

              <Divider sx={{ my: 2 }} />

              {/* Student Information */}
              <Box mb={4}>
                <Typography variant="h6" gutterBottom>
                  Student Information
                </Typography>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={6}>
                    <Paper elevation={1} sx={{ p: 2 }}>
                      <Typography variant="body2"><strong>Name:</strong> {selectedStudent.firstName} {selectedStudent.lastName}</Typography>
                      <Typography variant="body2"><strong>Email:</strong> {selectedStudent.email || 'N/A'}</Typography>
                      <Typography variant="body2"><strong>Mobile:</strong> {selectedStudent.mobile || 'N/A'}</Typography>
                    </Paper>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Paper elevation={1} sx={{ p: 2 }}>
                      <Typography variant="body2"><strong>Student ID:</strong> {selectedStudent.id}</Typography>
                      <Typography variant="body2"><strong>Total Courses:</strong> {studentEnrollments[selectedStudent.id]?.length || 0}</Typography>
                      <Typography variant="body2"><strong>Completed Courses:</strong> {studentEnrollments[selectedStudent.id]?.filter(e => getStatusColor(e.status) === 'primary').length || 0}</Typography>
                    </Paper>
                  </Grid>
                </Grid>
              </Box>

              {/* Course Enrollments */}
              <Box mb={4}>
                <Typography variant="h6" gutterBottom>
                  Course Enrollments ({studentEnrollments[selectedStudent.id]?.length || 0})
                </Typography>
                {studentEnrollments[selectedStudent.id]?.length > 0 ? (
                  <TableContainer component={Paper}>
                    <Table size="small">
                      <TableHead>
                        <TableRow>
                          <TableCell>#</TableCell>
                          <TableCell>Course Name</TableCell>
                          <TableCell>Code</TableCell>
                          <TableCell>Enrollment Date</TableCell>
                          <TableCell>Status</TableCell>
                          <TableCell>Progress</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {studentEnrollments[selectedStudent.id].map((enrollment, index) => (
                          <TableRow key={enrollment.id}>
                            <TableCell>{index + 1}</TableCell>
                            <TableCell>{enrollment.courseName}</TableCell>
                            <TableCell>{enrollment.courseCode}</TableCell>
                            <TableCell>
                              {new Date(enrollment.enrollmentDate).toLocaleDateString()}
                            </TableCell>
                            <TableCell>
                              <Chip 
                                label={enrollment.status}
                                size="small"
                                color={getStatusColor(enrollment.status)}
                                variant="outlined"
                              />
                            </TableCell>
                            <TableCell>
                              <Box display="flex" alignItems="center" gap={1}>
                                <Box sx={{ flexGrow: 1, bgcolor: '#e9ecef', borderRadius: 1, height: 8 }}>
                                  <Box 
                                    sx={{ 
                                      bgcolor: getStatusColor(enrollment.status) === 'success' ? '#4CAF50' : 
                                              getStatusColor(enrollment.status) === 'primary' ? '#2196F3' : '#FF9800',
                                      width: `${Math.min(enrollment.progress, 100)}%`,
                                      height: '100%',
                                      borderRadius: 1
                                    }} 
                                  />
                                </Box>
                                <Typography variant="body2" fontWeight="bold">
                                  {enrollment.progress}%
                                </Typography>
                              </Box>
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                ) : (
                  <Paper elevation={1} sx={{ p: 4, textAlign: 'center' }}>
                    <Typography color="textSecondary">
                      No course enrollments found for this student.
                    </Typography>
                  </Paper>
                )}
              </Box>

              {/* Summary */}
              {studentEnrollments[selectedStudent.id]?.length > 0 && (
                <Box>
                  <Typography variant="h6" gutterBottom>
                    Academic Summary
                  </Typography>
                  <Grid container spacing={2}>
                    <Grid item xs={6} sm={3}>
                      <Paper elevation={2} sx={{ p: 2, textAlign: 'center' }}>
                        <Typography variant="h5" color="primary.main">
                          {studentEnrollments[selectedStudent.id].length}
                        </Typography>
                        <Typography variant="body2" color="textSecondary">
                          Total Courses
                        </Typography>
                      </Paper>
                    </Grid>
                    <Grid item xs={6} sm={3}>
                      <Paper elevation={2} sx={{ p: 2, textAlign: 'center' }}>
                        <Typography variant="h5" color="success.main">
                          {studentEnrollments[selectedStudent.id].filter(e => getStatusColor(e.status) === 'success').length}
                        </Typography>
                        <Typography variant="body2" color="textSecondary">
                          Active
                        </Typography>
                      </Paper>
                    </Grid>
                    <Grid item xs={6} sm={3}>
                      <Paper elevation={2} sx={{ p: 2, textAlign: 'center' }}>
                        <Typography variant="h5" color="info.main">
                          {studentEnrollments[selectedStudent.id].filter(e => getStatusColor(e.status) === 'primary').length}
                        </Typography>
                        <Typography variant="body2" color="textSecondary">
                          Completed
                        </Typography>
                      </Paper>
                    </Grid>
                    <Grid item xs={6} sm={3}>
                      <Paper elevation={2} sx={{ p: 2, textAlign: 'center' }}>
                        <Typography variant="h5" color="warning.main">
                          {studentEnrollments[selectedStudent.id].filter(e => getStatusColor(e.status) === 'warning').length}
                        </Typography>
                        <Typography variant="body2" color="textSecondary">
                          In Progress
                        </Typography>
                      </Paper>
                    </Grid>
                  </Grid>
                </Box>
              )}
            </Box>
          )}
        </DialogContent>

        <DialogActions>
          <Button onClick={handleCloseReportDialog} color="secondary">
            Close
          </Button>
          <Button 
            onClick={() => {
              // Generate individual CSV report
              const enrollments = studentEnrollments[selectedStudent?.id] || []
              if (enrollments.length === 0) {
                toast.warning("No course data available")
                return
              }
              
              const csvRows = [
                'STUDENT COURSE REPORT',
                `Student: ${selectedStudent.firstName} ${selectedStudent.lastName}`,
                `Generated: ${new Date().toLocaleString()}`,
                '',
                'Course Code,Course Name,Status,Progress (%),Enrollment Date,Instructor',
                ...enrollments.map(e => [
                  e.courseCode,
                  `"${e.courseName}"`,
                  e.status,
                  e.progress,
                  new Date(e.enrollmentDate).toLocaleDateString(),
                  `"${e.instructor}"`
                ].join(','))
              ]
              
              const blob = new Blob([csvRows.join('\n')], { type: 'text/csv;charset=utf-8;' })
              const url = URL.createObjectURL(blob)
              const link = document.createElement('a')
              link.href = url
              link.download = `student_${selectedStudent.id}_courses.csv`
              link.click()
              URL.revokeObjectURL(url)
              
              toast.success("Individual report downloaded")
            }}
            color="primary"
            startIcon={<ExcelIcon />}
            disabled={!studentEnrollments[selectedStudent?.id]?.length}
          >
            CSV Report
          </Button>
          <Button 
            onClick={generateHTMLReport}
            color="info"
            startIcon={<DescriptionIcon />}
            disabled={!studentEnrollments[selectedStudent?.id]?.length}
          >
            HTML Report
          </Button>
          <Button 
            onClick={printReport}
            color="warning"
            startIcon={<PrintIcon />}
          >
            Print
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  )
}

export default connect(null, { setBreadcrumbItems })(AllStudents)